//product master
import React, { useState } from "react";
import Layout from "../../Component/Layout";
import axios from "axios";
import Select from "react-select";
import { hasPermission } from "../../utils/permission";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MASTER_API } from "../../apiConfig";

// Fixed set of review stages for RFQ Validity rules — kept in sync with
// REVIEW_TYPES in configuration.service.js (backend is the source of truth
// for validation; this list just drives the dropdown).
const REVIEW_TYPES = ["Manager Review", "Discount Review", "Review for Customer"];

// The backend saves file_path as e.g. "/uploads/seal-sign/xyz.png", served as a
// static file from the API server's root (not under /api). Strip a trailing
// "/api" (or "/api/...") from MASTER_API to get that root.
const SEAL_SIGN_FILE_BASE = MASTER_API.replace(/\/api(\/.*)?$/, "");

// Options for the Product Type "Usage" dropdown — multi-select
// (a product type can be tagged as Internal, External, or both).
const PRODUCT_TYPE_USAGE_OPTIONS = [
    { value: "Internal", label: "Internal" },
    { value: "External", label: "External" }
];

const ProductMaster = () => {

    const canView = hasPermission("PRODUCT_MASTER_DATA", "view");
    const canEdit = hasPermission("PRODUCT_MASTER_DATA", "edit");
    const canCreate = hasPermission("PRODUCT_MASTER_DATA", "create");
    //eslint-disable-next-line no-unused-vars
    const canApprove = hasPermission("PRODUCT_MASTER_DATA", "approve");
    const [searchTerm, setSearchTerm] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [currentType, setCurrentType] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [data, setData] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [mode, setMode] = useState("add");

    const [modalSearchTerm, setModalSearchTerm] = useState("");

    const [storageLocation, setStorageLocation] = useState("");
    const [storageCode, setStorageCode] = useState("");

    const [processName, setProcessName] = useState("");
    const [operationId, setOperationId] = useState("");
    const [workcenterName, setWorkcenterName] = useState("");
    const [workcenterDescription, setWorkcenterDescription] = useState("");
    const [hsnCode, setHsnCode] = useState("");
    const [cgst, setCgst] = useState("");
    const [sgst, setSgst] = useState("");
    const [igst, setIgst] = useState("");
    const [companyCodeName, setCompanyCodeName] = useState("");
    const [companyCode, setCompanyCode] = useState("");

    const [rejectionReason, setRejectionReason] = useState("");

    // COUNTRY (Country Name + Currency, currency options loaded from master — not hardcoded)
    const [countryName, setCountryName] = useState("");
    const [countryCurrencyId, setCountryCurrencyId] = useState("");
    const [countryCurrencyName, setCountryCurrencyName] = useState("");
    const [currencyMaster, setCurrencyMaster] = useState([]);

    const [subProcessName, setSubProcessName] = useState("");
    const [subProcessOperationId, setSubProcessOperationId] = useState("");
    const [subProcessProcessId, setSubProcessProcessId] = useState("");
    const [processMaster, setProcessMaster] = useState([]);

    const [processId, setProcessId] = useState("");
    const [processNameConfig, setProcessNameConfig] = useState("");
    const [subProcessId, setSubProcessId] = useState("");
    const [subProcessNameConfig, setSubProcessNameConfig] = useState("");
    const [processConfigLocation, setProcessConfigLocation] = useState("");
    const [locationMaster, setLocationMaster] = useState([]);
    const [groupIdConfig, setGroupIdConfig] = useState("");
    const [groupNameConfig, setGroupNameConfig] = useState("");

    const [workcenterConfigProcessId, setWorkcenterConfigProcessId] = useState("");
    const [workcenterConfigProcessName, setWorkcenterConfigProcessName] = useState("");

    const [workcenterConfigSubProcessId, setWorkcenterConfigSubProcessId] = useState("");
    const [workcenterConfigSubProcessName, setWorkcenterConfigSubProcessName] = useState("");

    const [workcenterConfigName, setWorkcenterConfigName] = useState("");
    const [workcenterConfigDescription, setWorkcenterConfigDescription] = useState("");

    const [processSubProcessData, setProcessSubProcessData] = useState([]);
    const [workcenterMaster, setWorkcenterMaster] = useState([]);
    const [workcenterNameConfig, setWorkcenterNameConfig] = useState("");
    const [workcenterDescriptionConfig, setWorkcenterDescriptionConfig] = useState("");
    const [sampleRequirementConfig, setSampleRequirementConfig] = useState("");

    // MODULE PROCESS CONFIG (plain manual text fields — no lookups)
    const [moduleProcessModule, setModuleProcessModule] = useState("");
    const [moduleProcessProcess, setModuleProcessProcess] = useState("");
    const [moduleProcessSubProcess, setModuleProcessSubProcess] = useState("");

    const [ittProductType, setIttProductType] = useState("");
    const [ittSequence, setIttSequence] = useState("");
    const [ittName, setIttName] = useState("");

    // MRP SEQUENCE
    const [mrpProductType, setMrpProductType] = useState("");
    const [mrpSlNo, setMrpSlNo] = useState("");
    const [mrpProcessInput, setMrpProcessInput] = useState("");
    const [mrpSubProcessInput, setMrpSubProcessInput] = useState("");

    // ID CREATION
    const [idCreationModule, setIdCreationModule] = useState("");
    const [idCreationPrefix, setIdCreationPrefix] = useState("");
    const [modulesList, setModulesList] = useState([]);

    // FILE SIZE CONFIG
    const [fileSizeModule, setFileSizeModule] = useState("");
    const [fileSizeMaxKb, setFileSizeMaxKb] = useState("");

    // RFQ VALIDITY CONFIG (rule = Module + Type of Review + Validity days)
    const [rfqValidityModule, setRfqValidityModule] = useState("");
    const [rfqValidityReviewType, setRfqValidityReviewType] = useState("");
    const [rfqValidityDays, setRfqValidityDays] = useState("");

    // TAX CONFIGURATION (rule = Country + Movement Type + Tax Type + Tax %)
    const [taxCountry, setTaxCountry] = useState("");
    const [taxMovementType, setTaxMovementType] = useState("");
    const [taxType, setTaxType] = useState("");
    const [taxCountryList, setTaxCountryList] = useState([]);
    const [taxMovementTypeList, setTaxMovementTypeList] = useState([]);
    const [glCode, setGlCode] = useState("");
    const [glCodeCategory, setGlCodeCategory] = useState("");
    const [glCodeType, setGlCodeType] = useState("");
    //eslint-disable-next-line
    const [glCodeCategoryList, setGlCodeCategoryList] = useState([]);
    //eslint-disable-next-line
    const [glCodeTypeList, setGlCodeTypeList] = useState([]);

    // SCRAP CONFIGURATION (rule = Process + Scrap Name)
    const [scrapProcessId, setScrapProcessId] = useState("");
    const [scrapName, setScrapName] = useState("");
    const [scrapProcessOptions, setScrapProcessOptions] = useState([]);
    const [scrapProcessLoading, setScrapProcessLoading] = useState(false);

    // PERCENTAGE CONFIG (standalone — just a percentage value)
    const [percentageValue, setPercentageValue] = useState("");

    // GOODS REQUEST SELECTION RULE (which fields must match when rows are
    // ticked together on Goods Request -> Active). Default = Workcenter only.
    const [grSelSameProductionOrder, setGrSelSameProductionOrder] = useState(false);
    const [grSelSameProductCode, setGrSelSameProductCode] = useState(false);
    const [grSelSameWorkcenter, setGrSelSameWorkcenter] = useState(true);
    // Max unique production order numbers selectable together (blank = no limit)
    const [grSelMaxProductionOrders, setGrSelMaxProductionOrders] = useState("");

    // IMPORT VALIDATION RULE (which columns of the Physical Inventory import
    // sheet are mandatory). Every column of the exported template can be
    // ticked. Default = Product Code + Batch Number.
    const IV_FIELD_OPTIONS = [
        { key: "product_code", label: "Product Code" },
        { key: "description", label: "Description" },
        { key: "batch_number", label: "Batch Number" },
        { key: "uom", label: "UOM" },
        { key: "system_qty", label: "System Qty" },
        { key: "actual_qty", label: "Actual Qty" },
        { key: "system_unit_price", label: "System Unit Price" },
        { key: "actual_unit_price", label: "Actual Unit Price" },
        { key: "system_storage_code", label: "System Storage Code" },
        { key: "system_storage_location", label: "System Storage Location" },
        { key: "actual_storage_code", label: "Actual Storage Code" },
        { key: "actual_storage_location", label: "Actual Storage Location" },
        { key: "status", label: "Status" }
    ];
    const IV_DEFAULT_FIELDS = ["product_code", "batch_number"];
    const [ivFields, setIvFields] = useState(IV_DEFAULT_FIELDS);
    const toggleIvField = (key, on) =>
        setIvFields((prev) => on ? [...new Set([...prev, key])] : prev.filter((k) => k !== key));

    // SEAL & SIGN (user dropdown sourced from usererp + a file upload)
    const [sealSignUsername, setSealSignUsername] = useState("");
    const [sealSignFile, setSealSignFile] = useState(null);
    const [sealSignUserOptions, setSealSignUserOptions] = useState([]);

    // PRODUCT TYPE — Usage (Internal / External, multi-select)
    const [productTypeUsage, setProductTypeUsage] = useState([]);

    // CURRENCY MASTER — Currency Code (e.g. INR, USD, EUR)
    const [currencyCode, setCurrencyCode] = useState("");
    const [currencySymbol, setCurrencySymbol] = useState("");

    // PERSON RESPONSIBLE MASTER — Phone Number + Email
    const [personPhone, setPersonPhone] = useState("");
    const [personEmail, setPersonEmail] = useState("");

    const [productTypes, setProductTypes] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [ittDrumAssignment, setIttDrumAssignment] = useState("");

    const [confirmBox, setConfirmBox] = useState({
        show: false,
        action: "",
        id: null
    });

    const loadWorkcenterConfigMasters = async () => {
        const [processRes, workcenterRes, locationRes] = await Promise.all([
            axios.get(`${MASTER_API}/configuration/dynamic/process-configuration`),
            axios.get(`${MASTER_API}/workcenter`),
            axios.get(`${MASTER_API}/configuration/dynamic/location`)
        ]);

        setProcessSubProcessData(processRes.data || []);
        setWorkcenterMaster(workcenterRes.data.data || []);
        setLocationMaster(locationRes.data || []);
    };




    // const [toast, setToast] = useState({
    //     show: false,
    //     message: "",
    //     type: "error" // success | error
    // });
    // const showToast = (message, type = "error") => {
    //     setToast({ show: true, message, type });

    //     setTimeout(() => {
    //         setToast({ show: false, message: "", type: "error" });
    //     }, 3000); // auto close in 3 sec
    // };

    const showToast = (message, type = "error") => {
        if (type === "success") {
            toast.success(message);
        } else {
            toast.error(message);
        }
    };
    //  SECTIONS (ALL 7)
    const sections = [
        "Product Group",
        "Product Type",
        "Plant",
        "Category",
        "Lab Category",
        "Sub Category",
        "Distribution Channel",
        "UOM",
        "Cable Type",
        "Construction",
        "No. of Cores",
        "Colour",
        "Costing Level",
        "Country",
        "State",
        "City",
        "Currency",
        "Location",
        "Division",
        "Person Responsible",
        "Capacity Responsible",
        "Business Partner Responsible",
        "Cost Center",
        "Controlling Area",
        "Mode Of Transport",
        "Delivery Type",
        "Freight Terms",
        "Insurance Terms",
        "Price Terms",
        "Transporter",
        "Purchase Type",
        "State Grouping",
        "PO Header Lot Type",
        "Sales Organization",
        "Customer Segment",
        "Test Type",
        "Inspection Test Type",
        "Shipping From",
        "MRP Planner",
        "Sales Person",
        "Workcenter category",
        "capacity category",
        "Factory Calender",
        "Machine Config",

        "Nominal Cross Section",
        "Reference Of Standard",
        "Voltage",
        "Code",
        "Process",

        "Storage Location",
        "Type of enquiry",
        "Purchase Organization",
        "Purchase Planner",
        "Quotation Type",
        "Quality Category",
        "Order Type",
        "Class Type",
        "Department",
        "HSN Code",
        "Company Code",
        "Customer Rejection Reason",
        "Process Configuration",
        "Workcenter Config",
        "Module Process Config",
        "Analysis Type",
        "MRP Sequence",
        "Payment Terms",
        "Movement Type",
        "Type of Packing",
        "Package Type",
        "Calibration Standard",
        "Number Range",
        "Asset Category",
        "File Size Config",
        "GL Category",
        "GL Type",
        "RFQ Validity",
        "Priority",
        "Developer",
        "Ticket Status",
        "Idle Reason",
        "Tax Configuration",
        "GL Code",
        "Percentage",
        "Scrap Configuration",
        "Goods Request Selection Rule",
        "Import Validation Rule",
        "Seal & Sign",

    ];

    const typeMap = {
        "Product Group": "product-groups",
        "Product Type": "product-types",
        "Plant": "plant",
        "Category": "category",
        "Lab Category": "lab-category",
        "Sub Category": "sub-category",
        "Distribution Channel": "distribution-channel",
        "UOM": "uom",

        "Cable Type": "cable-type",
        "Construction": "construction",
        "No. of Cores": "core",
        "Colour": "colour",
        "Costing Level": "costing-level",
        "Country": "country",
        "State": "state",
        "City": "city",
        "Currency": "currency",
        "Location": "location",
        "Division": "division",
        "Person Responsible": "person-responsible",
        "Capacity Responsible": "capacity-responsible",
        "Business Partner Responsible": "business-partner-responsible",
        "Cost Center": "cost-center",
        "Controlling Area": "controlling-area",
        "Mode Of Transport": "mode_of_transport",
        "Delivery Type": "delivery_type",
        "Freight Terms": "freight_terms",
        "Insurance Terms": "insurance_terms",
        "Price Terms": "price_terms",
        "Transporter": "transporter",
        "Purchase Type": "purchase_type",
        "State Grouping": "state_grouping",
        "PO Header Lot Type": "po_header_lot_type",
        "Sales Organization": "sales-organization",
        "Customer Segment": "customer-segment",
        "Test Type": "test-type",
        "Inspection Test Type": "inspection-test-type",
        "Shipping From": "shipping-from",
        "MRP Planner": "mrp-planner",
        "Sales Person": "sales-person",
        "Workcenter category": "workcenter-category",
        "capacity category": "capacity-category",
        "Factory Calender": "factory-calendar",
        "Machine Config": "machine-config",

        "Nominal Cross Section": "nominal-cross-section",
        "Reference Of Standard": "reference-of-standard",
        "Voltage": "voltage",
        "Code": "code",
        "Process": "process",

        "Storage Location": "storage-location",
        "Type of enquiry": "type-of-enquiry",
        "Quotation Type": "quotation-type",
        "Purchase Organization": "purchase-organization",
        "Purchase Planner": "purchase-planner",
        "Quality Category": "quality-category",
        "Order Type": "order-type",
        "Class Type": "class-type",
        "Department": "department",
        "HSN Code": "hsn-code",
        "Company Code": "company-code",
        "Customer Rejection Reason": "customer-rejection-reason",
        "Process Configuration": "process-configuration",
        "Workcenter Config": "workcenter-config",
        "Module Process Config": "module-process-config",
        "Analysis Type": "analysis-type",
        "MRP Sequence": "mrp-sequence",
        "Payment Terms": "payment-terms",
        "Movement Type": "movement-type",
        "Type of Packing": "type-of-packing",
        "Package Type": "package-type",
        "Calibration Standard": "calibration-standard",
        "Number Range": "id-creation",
        "Asset Category": "asset-category",
        "File Size Config": "file-size-config",
        "GL Category": "gl-category",
        "GL Type": "gl-type",
        "Priority": "priority",
        "Developer": "developer",
        "Ticket Status": "ticket-status",
        "Idle Reason": "idle-reason",
        "RFQ Validity": "rfq-validity",
        "Tax Configuration": "tax-config",
        "GL Code": "gl-config",
        "Scrap Configuration": "scrap-config",
        "Percentage": "percentage-config",
        "Goods Request Selection Rule": "goods-request-selection-config",
        "Import Validation Rule": "import-validation-config",
        "Seal & Sign": "seal-sign",

    };

    const fetchData = async (type, search = "") => {

        try {

            let url = "";

            if (type === "Storage Location") {

                url =
                    `${MASTER_API}/configuration/storage-location?search=${search}`;

            }
            else if (type === "Inspection Test Type") {
                url = `${MASTER_API}/configuration/inspection-test-type`;
            }
            else if (type === "Machine Config") {

                url =
                    `${MASTER_API}/configuration/machine-config`;

            }
            else if (type === "HSN Code") {

                url =
                    `${MASTER_API}/configuration/hsn-code`;

            }
            else if (type === "Company Code") {

                url =
                    `${MASTER_API}/configuration/company-code`;

            }
            else if (type === "Customer Rejection Reason") {

                url =
                    `${MASTER_API}/configuration/customer-rejection-reason`;

            }
            else if (type === "Workcenter Config") {

                url =
                    `${MASTER_API}/configuration/workcenter-config`;

            }
            else if (type === "MRP Sequence") {

                url =
                    `${MASTER_API}/configuration/mrp-sequence`;

            }
            else if (type === "Number Range") {

                url =
                    `${MASTER_API}/configuration/id-creation`;

            }
            else if (type === "File Size Config") {

                url =
                    `${MASTER_API}/configuration/file-size-config`;

            }
            else if (type === "RFQ Validity") {

                url =
                    `${MASTER_API}/configuration/rfq-validity`;

            }
            else if (type === "Tax Configuration") {

                url =
                    `${MASTER_API}/configuration/tax-config`;

            }
            else if (type === "GL Code") {

                url =
                    `${MASTER_API}/configuration/gl-config`;

            }
            else if (type === "Percentage") {

                url =
                    `${MASTER_API}/configuration/percentage-config`;

            }
            else if (type === "Scrap Configuration") {

                url =
                    `${MASTER_API}/configuration/scrap-config`;

            }
            else if (type === "Import Validation Rule") {

                url =
                    `${MASTER_API}/configuration/import-validation-config`;

            }

            else if (type === "Goods Request Selection Rule") {

                url =
                    `${MASTER_API}/configuration/goods-request-selection-config`;

            }

            else if (type === "Seal & Sign") {

                url =
                    `${MASTER_API}/configuration/seal-sign`;

            }

            else {

                url =
                    `${MASTER_API}/configuration/dynamic/${typeMap[type]}?search=${search}`;

            }

            const res = await axios.get(url);

            setData(res.data);

        } catch (err) {

            console.error(err);

        }

    };

    const loadProcessMaster = async () => {

        try {

            const res = await axios.get(
                `${MASTER_API}/configuration/dynamic/process`
            );

            setProcessMaster(
                res.data || []
            );

        } catch (err) {

            console.error(err);

        }

    };

    const loadStorageMasters = async () => {
        try {

            const [productRes, deptRes] = await Promise.all([
                axios.get(
                    `${MASTER_API}/configuration/product-types`
                ),
                axios.get(
                    `${MASTER_API}/configuration/dynamic/department`
                )
            ]);

            setProductTypes(productRes.data || []);
            setDepartments(deptRes.data || []);

        } catch (err) {

            console.error(err);

        }
    };


    const loadMrpSequenceMasters = async () => {
        try {
            const productRes = await axios.get(`${MASTER_API}/configuration/product-types`);
            setProductTypes(productRes.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    // Splits "8125-Process Name" into { id: "8125", name: "Process Name" }
    const parseIdName = (raw) => {
        if (!raw || !raw.trim()) return { id: "", name: "" };
        const parts = raw.split("-");
        const id = (parts[0] || "").trim();
        const name = parts.slice(1).join("-").trim();
        return { id, name: name || id };
    };

    // Process dropdown for Scrap Configuration — sourced from Process
    // Configuration (unique Process ID + Process Name).
    const loadScrapProcessOptions = async () => {
        setScrapProcessLoading(true);
        try {
            const res = await axios.get(`${MASTER_API}/configuration/dynamic/process-configuration`);
            const seen = new Set();
            const options = [];
            (res.data || []).forEach(r => {
                if (r.process_id && !seen.has(String(r.process_id))) {
                    seen.add(String(r.process_id));
                    options.push({
                        id: String(r.process_id),
                        name: r.process_name,
                        label: `${r.process_id} - ${r.process_name}`
                    });
                }
            });
            setScrapProcessOptions(options);
        } catch (err) {
            console.error(err);
            showToast(err.response?.data?.error || "Unable to load processes", "error");
        } finally {
            setScrapProcessLoading(false);
        }
    };

    const openModal = (type, action) => {
        setCurrentType(type);
        setShowModal(true);
        setMode(action);
        setInputValue("");
        setEditingId(null);
        setModalSearchTerm("");

        fetchData(type);

        if (type === "Sub Process") {
            loadProcessMaster();
        }

        if (type === "Scrap Configuration") {
            loadScrapProcessOptions();
        }

        if (type === "Storage Location") {
            loadStorageMasters();
        }
        if (type === "Inspection Test Type") {
            axios.get(`${MASTER_API}/configuration/product-types`).then(res => {
                setProductTypes(res.data || []);
            });
        }

        if (
            type === "Workcenter Config" ||
            type === "Process Configuration"
        ) {
            loadWorkcenterConfigMasters();
        }

        if (type === "MRP Sequence") {
            loadMrpSequenceMasters();
        }

        if (type === "Number Range" || type === "File Size Config" || type === "RFQ Validity") {
            axios.get(`${MASTER_API}/configuration/dynamic/module`).then(res => {
                setModulesList(res.data || []);
            });
        }

        if (type === "Tax Configuration") {
            axios.get(`${MASTER_API}/configuration/dynamic/country`).then(res => {
                setTaxCountryList(res.data || []);
            });
            axios.get(`${MASTER_API}/configuration/dynamic/movement-type`).then(res => {
                setTaxMovementTypeList(res.data || []);
            });
        }

        if (type === "Country") {
            axios.get(`${MASTER_API}/configuration/dynamic/currency`).then(res => {
                setCurrencyMaster(res.data || []);
            });
        }

        if (type === "Seal & Sign") {
            axios.get(`${MASTER_API}/configuration/seal-sign/users`).then(res => {
                setSealSignUserOptions(res.data || []);
            });
        }


    };

    const closeModal = () => {
        setShowModal(false);
        setInputValue("");
        setStorageLocation("");
        setStorageCode("");
        setOperationId("");
        setProcessName("");
        setSubProcessName("");
        setSubProcessOperationId("");
        setSubProcessProcessId("");
        setWorkcenterName("");
        setWorkcenterDescription("");
        setHsnCode("");
        setCgst("");
        setSgst("");
        setIgst("");
        setRejectionReason("");
        setEditingId(null);
        setProcessId("");
        setProcessNameConfig("");
        setWorkcenterNameConfig("");
        setWorkcenterDescriptionConfig("");
        setSampleRequirementConfig("");
        setSubProcessId("");
        setSubProcessNameConfig("");
        setGroupIdConfig("");
        setGroupNameConfig("");
        setSelectedProductType(null);
        setSelectedDepartment(null);
        setIttProductType("");
        setIttSequence("");
        setIttName("");
        setModalSearchTerm("");
        setIttDrumAssignment("");
        setMrpProductType("");
        setMrpSlNo("");
        setMrpProcessInput("");
        setMrpSubProcessInput("");
        setIdCreationModule("");
        setIdCreationPrefix("");
        setFileSizeModule("");
        setFileSizeMaxKb("");
        setRfqValidityModule("");
        setRfqValidityReviewType("");
        setRfqValidityDays("");
        setTaxCountry("");
        setTaxMovementType("");
        setTaxType("");
        setGlCode("");
        setGlCodeCategory("");
        setGlCodeType("");
        setPercentageValue("");
        setGrSelSameProductionOrder(false);
        setGrSelSameProductCode(false);
        setGrSelSameWorkcenter(true);
        setGrSelMaxProductionOrders("");
        setIvFields(IV_DEFAULT_FIELDS);
        setScrapProcessId("");
        setScrapName("");
        setModuleProcessModule("");
        setModuleProcessProcess("");
        setModuleProcessSubProcess("");
        setProcessConfigLocation("");
        setCountryName("");
        setCountryCurrencyId("");
        setCountryCurrencyName("");
        setProductTypeUsage([]);
        setCurrencyCode("");
        setCurrencySymbol("");
        setPersonPhone("");
        setPersonEmail("");
        setSealSignUsername("");
        setSealSignFile(null);
    };

    //  SAVE 
    const handleSave = () => {

        // STORAGE LOCATION

        if (currentType === "Storage Location") {

            if (
                !selectedProductType ||
                !selectedDepartment ||
                !storageLocation.trim() ||
                !storageCode.trim()
            ) {
                showToast(
                    "Please fill all fields",
                    "error"
                );
                return;
            }
        }

        else if (currentType === "Process") {

            if (
                !operationId.trim() ||
                !processName.trim()
            ) {

                showToast(
                    "Please fill all fields",
                    "error"
                );

                return;
            }

        }

        else if (currentType === "Sub Process") {

            if (
                !subProcessProcessId ||
                !subProcessName.trim()
            ) {

                showToast(
                    "Please fill all fields",
                    "error"
                );

                return;

            }

        }
        else if (currentType === "Machine Config") {

            if (
                !workcenterName.trim() ||
                !workcenterDescription.trim()
            ) {

                showToast(
                    "Please fill all fields",
                    "error"
                );

                return;
            }

        }
        else if (currentType === "Process Configuration") {

            if (!processNameConfig.trim()) {
                showToast("Process Name is mandatory", "error");
                return;
            }

            if (!processConfigLocation) {
                showToast("Location is mandatory", "error");
                return;
            }
        }
        else if (currentType === "Workcenter Config") {

            if (
                !workcenterConfigProcessId ||
                !workcenterConfigProcessName
            ) {

                showToast(
                    "Process ID and Process Name are mandatory",
                    "error"
                );

                return;
            }

        }

        else if (currentType === "Module Process Config") {

            if (
                !moduleProcessModule.trim()
            ) {

                showToast(
                    "Module are mandatory",
                    "error"
                );

                return;
            }

        }

        else if (currentType === "HSN Code") {
            if (!hsnCode?.trim()) {
                showToast("HSN Code is mandatory", "error");
                return;
            }
        }

        else if (currentType === "Company Code") {
            if (!companyCodeName?.trim() || !companyCode?.trim()) {
                showToast("Company Name and Company Code are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Customer Rejection Reason") {
            if (!rejectionReason?.trim()) {
                showToast("Rejection Reason is mandatory", "error");
                return;
            }
        }

        else if (currentType === "Country") {
            if (!countryName?.trim() || !countryCurrencyId) {
                showToast("Country Name and Currency are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Inspection Test Type") {
            if (!ittProductType || !ittSequence || !ittName.trim()) {
                showToast("Please fill all fields", "error");
                return;
            }
        }

        else if (currentType === "MRP Sequence") {
            if (!mrpProductType || !mrpSlNo || !mrpProcessInput.trim()) {
                showToast("Product Type, Sl No and Process are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Number Range") {
            if (!idCreationModule || !idCreationPrefix.trim()) {
                showToast("Module and Prefix are mandatory", "error");
                return;
            }
        }

        else if (currentType === "File Size Config") {
            if (!fileSizeModule || !fileSizeMaxKb || isNaN(fileSizeMaxKb) || Number(fileSizeMaxKb) <= 0) {
                showToast("Module and a valid Max Size (KB) are mandatory", "error");
                return;
            }
        }

        else if (currentType === "RFQ Validity") {
            if (!rfqValidityModule || !rfqValidityReviewType || !rfqValidityDays || isNaN(rfqValidityDays) || Number(rfqValidityDays) <= 0) {
                showToast("Module, Type of Review and a valid Validity (days) are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Tax Configuration") {
            if (!taxCountry || !taxMovementType || !taxType) {
                showToast("Country, Movement Type and Tax Type are mandatory", "error");
                return;
            }
        }

        else if (currentType === "GL Code") {
            if (!glCodeCategory || !glCodeType || !glCode) {
                showToast("GL Category, GL Type and GL Code are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Scrap Configuration") {
            if (!scrapProcessId || !scrapName.trim()) {
                showToast("Process and Scrap Name are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Import Validation Rule") {
            if (ivFields.length === 0) {
                showToast("Select at least one field that must be mandatory in the import sheet", "error");
                return;
            }
        }

        else if (currentType === "Goods Request Selection Rule") {
            if (!grSelSameProductionOrder && !grSelSameProductCode && !grSelSameWorkcenter) {
                showToast("Select at least one option (Production Order Number, Product Code or Workcenter)", "error");
                return;
            }
            if (String(grSelMaxProductionOrders).trim() !== "") {
                const n = Number(grSelMaxProductionOrders);
                if (!Number.isInteger(n) || n < 1) {
                    showToast("Max Production Orders must be a whole number (1 or more), or blank for no limit", "error");
                    return;
                }
            }
        }

        else if (currentType === "Percentage") {
            if (percentageValue === "" || isNaN(percentageValue) || Number(percentageValue) < 0) {
                showToast("A valid Percentage is mandatory", "error");
                return;
            }
        }

        else if (currentType === "Seal & Sign") {
            if (!sealSignUsername) {
                showToast("Please select a user", "error");
                return;
            }
            if (!editingId && !sealSignFile) {
                showToast("Please choose a seal/sign file to upload", "error");
                return;
            }
        }

        else if (currentType === "Currency") {
            if (!inputValue.trim() || !currencyCode.trim() || !currencySymbol.trim()) {
                showToast("Currency Name, Currency Code and Currency Symbol are mandatory", "error");
                return;
            }
        }

        else if (currentType === "Business Partner Responsible") {
            if (!inputValue.trim() || !personPhone.trim() || !personEmail.trim()) {
                showToast("Name, Phone Number and Email are mandatory", "error");
                return;
            }
            if (!/^[0-9+\-\s()]{7,20}$/.test(personPhone.trim())) {
                showToast("Please enter a valid phone number", "error");
                return;
            }
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(personEmail.trim())) {
                showToast("Please enter a valid email address", "error");
                return;
            }
        }

        else if (currentType === "Product Type") {
            if (!inputValue.trim() || !productTypeUsage || productTypeUsage.length === 0) {
                showToast("Name and Usage (Internal/External) are mandatory", "error");
                return;
            }
        }

        else {

            // EXISTING CONFIGURATION

            if (!inputValue.trim()) {
                return;
            }

        }

        setConfirmBox({
            show: true,
            action: editingId ? "update" : "add",
            id: null
        });
    };

    //  DELETE 
    const handleDelete = (id) => {
        setConfirmBox({
            show: true,
            action: "delete",
            id: id
        });
    };

    //  CONFIRM 
    const handleConfirm = async () => {
        try {
            const apiType = typeMap[currentType];

            if (confirmBox.action === "add") {

                if (currentType === "Storage Location") {

                    await axios.post(
                        `${MASTER_API}/configuration/storage-location`,
                        {
                            product_type_id: selectedProductType?.id,
                            product_type_name: selectedProductType?.name,

                            department_id: selectedDepartment?.id,
                            department_name: selectedDepartment?.name,

                            storage_location: storageLocation,
                            storage_code: storageCode
                        }
                    );

                }

                else if (currentType === "Process") {

                    await axios.post(
                        `${MASTER_API}/configuration/${apiType}`,
                        {
                            operation_id: operationId,
                            name: processName
                        }
                    );

                }

                else if (currentType === "Sub Process") {

                    await axios.post(
                        `${MASTER_API}/configuration/${apiType}`,
                        {
                            process_id: subProcessProcessId,
                            operation_id: subProcessOperationId,
                            name: subProcessName
                        }
                    );

                }

                else if (currentType === "Process Configuration") {

                    await axios.post(
                        `${MASTER_API}/configuration/process-configuration`,
                        {
                            process_id: processId,
                            process_name: processNameConfig,
                            sub_process_id: subProcessId || null,
                            sub_process_name: subProcessNameConfig || null,
                            location: processConfigLocation,
                            group_id: groupIdConfig || null,
                            group_name: groupNameConfig || null,
                            workcenter_name: workcenterNameConfig || null,
                            workcenter_description: workcenterDescriptionConfig || null,
                            sample_requirement: sampleRequirementConfig || null
                        }
                    );
                }

                else if (currentType === "Workcenter Config") {

                    await axios.post(
                        `${MASTER_API}/configuration/workcenter-config`,
                        {
                            process_id: workcenterConfigProcessId,
                            process_name: workcenterConfigProcessName,
                            sub_process_id: workcenterConfigSubProcessId || null,
                            sub_process_name: workcenterConfigSubProcessName || null,
                            workcenter_name: workcenterConfigName || null,
                            workcenter_description: workcenterConfigDescription || null
                        }
                    );

                }

                else if (currentType === "Module Process Config") {

                    await axios.post(
                        `${MASTER_API}/configuration/module-process-config`,
                        {
                            module_name: moduleProcessModule,
                            process_name: moduleProcessProcess,
                            sub_process_name: moduleProcessSubProcess
                        }
                    );

                }

                else if (currentType === "Machine Config") {

                    await axios.post(
                        `${MASTER_API}/configuration/machine-config`,
                        {
                            machine_name: workcenterName,
                            machine_description: workcenterDescription
                        }
                    );

                }

                else if (currentType === "HSN Code") {

                    await axios.post(
                        `${MASTER_API}/configuration/hsn-code`,
                        {
                            hsn_code: hsnCode,
                            cgst,
                            sgst,
                            igst
                        }
                    );

                }

                else if (currentType === "Company Code") {

                    await axios.post(
                        `${MASTER_API}/configuration/company-code`,
                        {
                            company_name: companyCodeName,
                            company_code: companyCode
                        }
                    );

                }

                else if (currentType === "Customer Rejection Reason") {

                    await axios.post(
                        `${MASTER_API}/configuration/customer-rejection-reason`,
                        {
                            reason: rejectionReason
                        }
                    );

                }

                else if (currentType === "Country") {

                    await axios.post(
                        `${MASTER_API}/configuration/${apiType}`,
                        {
                            name: countryName,
                            currency_id: countryCurrencyId
                        }
                    );

                }

                else if (currentType === "Inspection Test Type") {

                    await axios.post(
                        `${MASTER_API}/configuration/inspection-test-type`,
                        {
                            product_type: ittProductType,
                            sequence: ittSequence,
                            name: ittName,
                            drum_assignment:
                                ittProductType?.trim().toUpperCase() === "FINISHED GOODS"
                                    ? ittDrumAssignment
                                    : null
                        }
                    );

                }

                else if (currentType === "MRP Sequence") {

                    const proc = parseIdName(mrpProcessInput);
                    const subProc = parseIdName(mrpSubProcessInput);

                    await axios.post(
                        `${MASTER_API}/configuration/mrp-sequence`,
                        {
                            product_type: mrpProductType,
                            sl_no: mrpSlNo,
                            process_id: proc.id || null,
                            process_name: proc.name || null,
                            sub_process_id: subProc.id || null,
                            sub_process_name: subProc.name || null
                        }
                    );

                }

                else if (currentType === "Number Range") {

                    await axios.post(
                        `${MASTER_API}/configuration/id-creation`,
                        {
                            module_name: idCreationModule,
                            prefix: idCreationPrefix
                        }
                    );

                }

                else if (currentType === "File Size Config") {

                    await axios.post(
                        `${MASTER_API}/configuration/file-size-config`,
                        {
                            module_name: fileSizeModule,
                            max_size_kb: fileSizeMaxKb
                        }
                    );

                }

                else if (currentType === "RFQ Validity") {

                    await axios.post(
                        `${MASTER_API}/configuration/rfq-validity`,
                        {
                            module_name: rfqValidityModule,
                            review_type: rfqValidityReviewType,
                            validity_days: rfqValidityDays
                        }
                    );

                }

                else if (currentType === "Tax Configuration") {

                    await axios.post(
                        `${MASTER_API}/configuration/tax-config`,
                        {
                            country: taxCountry,
                            movement_type: taxMovementType,
                            tax_type: taxType
                        }
                    );

                }

                else if (currentType === "GL Code") {

                    await axios.post(
                        `${MASTER_API}/configuration/gl-config`,
                        {
                            gl_category: glCodeCategory,
                            gl_type: glCodeType,
                            gl_code: glCode
                        }
                    );

                }

                else if (currentType === "Scrap Configuration") {

                    await axios.post(
                        `${MASTER_API}/configuration/scrap-config`,
                        {
                            process_id: scrapProcessId,
                            process_name: scrapProcessOptions.find(p => p.id === scrapProcessId)?.name || "",
                            scrap_name: scrapName.trim()
                        }
                    );

                }

                else if (currentType === "Import Validation Rule") {

                    await axios.post(
                        `${MASTER_API}/configuration/import-validation-config`,
                        { required_fields: ivFields }
                    );

                }

                else if (currentType === "Goods Request Selection Rule") {

                    await axios.post(
                        `${MASTER_API}/configuration/goods-request-selection-config`,
                        {
                            same_production_order: grSelSameProductionOrder,
                            same_product_code: grSelSameProductCode,
                            same_workcenter: grSelSameWorkcenter,
                            max_production_orders: grSelMaxProductionOrders === "" ? null : Number(grSelMaxProductionOrders)
                        }
                    );

                }

                else if (currentType === "Percentage") {

                    await axios.post(
                        `${MASTER_API}/configuration/percentage-config`,
                        {
                            percent: percentageValue
                        }
                    );

                }

                else if (currentType === "Seal & Sign") {

                    const sealSignFormData = new FormData();
                    sealSignFormData.append("username", sealSignUsername);
                    if (sealSignFile) {
                        sealSignFormData.append("seal_sign_file", sealSignFile);
                    }

                    await axios.post(
                        `${MASTER_API}/configuration/seal-sign`,
                        sealSignFormData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );

                }


                else if (currentType === "Currency") {

                    await axios.post(
                        `${MASTER_API}/configuration/currency`,
                        {
                            name: inputValue,
                            currency_code: currencyCode,
                            currency_symbol: currencySymbol
                        }
                    );

                }

                else if (currentType === "Business Partner Responsible") {

                    await axios.post(
                        `${MASTER_API}/configuration/${apiType}`,
                        {
                            name: inputValue,
                            phone_number: personPhone,
                            email: personEmail
                        }
                    );

                }

                else if (currentType === "Product Type") {

                    await axios.post(
                        `${MASTER_API}/configuration/product-types`,
                        {
                            name: inputValue,
                            usage: productTypeUsage.map(u => u.value).join(",")
                        }
                    );

                }

                else {

                    await axios.post(
                        `${MASTER_API}/configuration/${apiType}`,
                        {
                            name: inputValue
                        }
                    );

                }

                showToast("Added successfully", "success");
            }

            if (confirmBox.action === "update") {

                if (currentType === "Storage Location") {

                    await axios.put(
                        `${MASTER_API}/configuration/storage-location/${editingId}`,
                        {
                            product_type_id: selectedProductType?.id,
                            product_type_name: selectedProductType?.name,

                            department_id: selectedDepartment?.id,
                            department_name: selectedDepartment?.name,

                            storage_location: storageLocation,
                            storage_code: storageCode
                        }
                    );

                }

                else if (currentType === "Process Configuration") {

                    await axios.put(
                        `${MASTER_API}/configuration/process-configuration/${editingId}`,
                        {
                            process_id: processId,
                            process_name: processNameConfig,
                            sub_process_id: subProcessId || null,
                            sub_process_name: subProcessNameConfig || null,
                            location: processConfigLocation,
                            group_id: groupIdConfig || null,
                            group_name: groupNameConfig || null,
                            workcenter_name: workcenterNameConfig || null,
                            workcenter_description: workcenterDescriptionConfig || null,
                            sample_requirement: sampleRequirementConfig || null
                        }
                    );
                }

                else if (currentType === "Workcenter Config") {

                    await axios.put(
                        `${MASTER_API}/configuration/workcenter-config/${editingId}`,
                        {
                            process_id: workcenterConfigProcessId,
                            process_name: workcenterConfigProcessName,
                            sub_process_id: workcenterConfigSubProcessId || null,
                            sub_process_name: workcenterConfigSubProcessName || null,
                            workcenter_name: workcenterConfigName || null,
                            workcenter_description: workcenterConfigDescription || null
                        }
                    );

                }

                else if (currentType === "Module Process Config") {

                    await axios.put(
                        `${MASTER_API}/configuration/module-process-config/${editingId}`,
                        {
                            module_name: moduleProcessModule,
                            process_name: moduleProcessProcess,
                            sub_process_name: moduleProcessSubProcess
                        }
                    );

                }

                else if (currentType === "Process") {

                    await axios.put(
                        `${MASTER_API}/configuration/${apiType}/${editingId}`,
                        {
                            operation_id: operationId,
                            name: processName
                        }
                    );

                }

                else if (currentType === "Machine Config") {

                    await axios.put(
                        `${MASTER_API}/configuration/machine-config/${editingId}`,
                        {
                            machine_name: workcenterName,
                            machine_description: workcenterDescription
                        }
                    );

                }

                else if (currentType === "HSN Code") {

                    await axios.put(
                        `${MASTER_API}/configuration/hsn-code/${editingId}`,
                        {
                            hsn_code: hsnCode,
                            cgst,
                            sgst,
                            igst
                        }
                    );

                }

                else if (currentType === "Company Code") {

                    await axios.put(
                        `${MASTER_API}/configuration/company-code/${editingId}`,
                        {
                            company_name: companyCodeName,
                            company_code: companyCode
                        }
                    );

                }

                else if (currentType === "Customer Rejection Reason") {

                    await axios.put(
                        `${MASTER_API}/configuration/customer-rejection-reason/${editingId}`,
                        {
                            reason: rejectionReason
                        }
                    );

                }

                else if (currentType === "Country") {

                    await axios.put(
                        `${MASTER_API}/configuration/${apiType}/${editingId}`,
                        {
                            name: countryName,
                            currency_id: countryCurrencyId
                        }
                    );

                }

                else if (currentType === "Inspection Test Type") {

                    await axios.put(
                        `${MASTER_API}/configuration/inspection-test-type/${editingId}`,
                        {
                            product_type: ittProductType,
                            sequence: ittSequence,
                            name: ittName,
                            drum_assignment:
                                ittProductType?.trim().toUpperCase() === "FINISHED GOODS"
                                    ? ittDrumAssignment
                                    : null
                        }
                    );

                }

                else if (currentType === "MRP Sequence") {

                    const proc = parseIdName(mrpProcessInput);
                    const subProc = parseIdName(mrpSubProcessInput);

                    await axios.put(
                        `${MASTER_API}/configuration/mrp-sequence/${editingId}`,
                        {
                            product_type: mrpProductType,
                            sl_no: mrpSlNo,
                            process_id: proc.id || null,
                            process_name: proc.name || null,
                            sub_process_id: subProc.id || null,
                            sub_process_name: subProc.name || null
                        }
                    );

                }

                else if (currentType === "Number Range") {

                    await axios.put(
                        `${MASTER_API}/configuration/id-creation/${editingId}`,
                        {
                            module_name: idCreationModule,
                            prefix: idCreationPrefix
                        }
                    );

                }

                else if (currentType === "File Size Config") {

                    await axios.put(
                        `${MASTER_API}/configuration/file-size-config/${editingId}`,
                        {
                            module_name: fileSizeModule,
                            max_size_kb: fileSizeMaxKb
                        }
                    );

                }

                else if (currentType === "RFQ Validity") {

                    await axios.put(
                        `${MASTER_API}/configuration/rfq-validity/${editingId}`,
                        {
                            module_name: rfqValidityModule,
                            review_type: rfqValidityReviewType,
                            validity_days: rfqValidityDays
                        }
                    );

                }

                else if (currentType === "Tax Configuration") {

                    await axios.put(
                        `${MASTER_API}/configuration/tax-config/${editingId}`,
                        {
                            country: taxCountry,
                            movement_type: taxMovementType,
                            tax_type: taxType
                        }
                    );

                }

                else if (currentType === "GL Code") {

                    await axios.put(
                        `${MASTER_API}/configuration/gl-config/${editingId}`,
                        {
                            gl_category: glCodeCategory,
                            gl_type: glCodeType,
                            gl_code: glCode
                        }
                    );

                }

                else if (currentType === "Scrap Configuration") {

                    await axios.put(
                        `${MASTER_API}/configuration/scrap-config/${editingId}`,
                        {
                            process_id: scrapProcessId,
                            process_name: scrapProcessOptions.find(p => p.id === scrapProcessId)?.name || "",
                            scrap_name: scrapName.trim()
                        }
                    );

                }

                else if (currentType === "Import Validation Rule") {

                    await axios.put(
                        `${MASTER_API}/configuration/import-validation-config/${editingId}`,
                        { required_fields: ivFields }
                    );

                }

                else if (currentType === "Goods Request Selection Rule") {

                    await axios.put(
                        `${MASTER_API}/configuration/goods-request-selection-config/${editingId}`,
                        {
                            same_production_order: grSelSameProductionOrder,
                            same_product_code: grSelSameProductCode,
                            same_workcenter: grSelSameWorkcenter,
                            max_production_orders: grSelMaxProductionOrders === "" ? null : Number(grSelMaxProductionOrders)
                        }
                    );

                }

                else if (currentType === "Percentage") {

                    await axios.put(
                        `${MASTER_API}/configuration/percentage-config/${editingId}`,
                        {
                            percent: percentageValue
                        }
                    );

                }

                else if (currentType === "Seal & Sign") {

                    const sealSignFormData = new FormData();
                    sealSignFormData.append("username", sealSignUsername);
                    if (sealSignFile) {
                        sealSignFormData.append("seal_sign_file", sealSignFile);
                    }

                    await axios.put(
                        `${MASTER_API}/configuration/seal-sign/${editingId}`,
                        sealSignFormData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );

                }


                else if (currentType === "Currency") {

                    await axios.put(
                        `${MASTER_API}/configuration/currency/${editingId}`,
                        {
                            name: inputValue,
                            currency_code: currencyCode,
                            currency_symbol: currencySymbol
                        }
                    );

                }

                else if (currentType === "Business Partner Responsible") {

                    await axios.put(
                        `${MASTER_API}/configuration/${apiType}/${editingId}`,
                        {
                            name: inputValue,
                            phone_number: personPhone,
                            email: personEmail
                        }
                    );

                }

                else if (currentType === "Product Type") {

                    await axios.put(
                        `${MASTER_API}/configuration/product-types/${editingId}`,
                        {
                            name: inputValue,
                            usage: productTypeUsage.map(u => u.value).join(",")
                        }
                    );

                }

                else {

                    await axios.put(
                        `${MASTER_API}/configuration/${apiType}/${editingId}`,
                        {
                            name: inputValue
                        }
                    );

                }

                showToast("Updated successfully", "success");
            }

            if (confirmBox.action === "delete") {

                if (currentType === "Workcenter Config") {

                    await axios.delete(
                        `${MASTER_API}/configuration/workcenter-config/${confirmBox.id}`
                    );

                } else {

                    await axios.delete(
                        `${MASTER_API}/configuration/${apiType}/${confirmBox.id}`
                    );

                }

                showToast("Deleted successfully", "success");
            }

            setConfirmBox({ show: false, action: "", id: null });

            setInputValue("");
            setStorageLocation("");
            setStorageCode("");
            setOperationId("");
            setProcessName("");

            setSubProcessName("");
            setSubProcessOperationId("");
            setSubProcessProcessId("");

            setWorkcenterName("");
            setWorkcenterDescription("");

            setHsnCode("");
            setCgst("");
            setSgst("");
            setIgst("");

            setCompanyCodeName("");
            setCompanyCode("");

            setRejectionReason("");

            // Process Configuration Reset
            setProcessId("");
            setProcessNameConfig("");
            setSubProcessId("");
            setSubProcessNameConfig("");
            setProcessConfigLocation("");
            setGroupIdConfig("");
            setGroupNameConfig("");
            setWorkcenterNameConfig("");
            setWorkcenterDescriptionConfig("");
            setSampleRequirementConfig("");

            // Workcenter Config Reset
            setWorkcenterConfigProcessId("");
            setWorkcenterConfigProcessName("");
            setWorkcenterConfigSubProcessId("");
            setWorkcenterConfigSubProcessName("");
            setWorkcenterConfigName("");
            setWorkcenterConfigDescription("");

            setEditingId(null);
            setSelectedProductType(null);
            setSelectedDepartment(null);
            setProductTypeUsage([]);
            setCurrencyCode("");
            setCurrencySymbol("");
            setPersonPhone("");
            setPersonEmail("");

            setIttProductType("");
            setIttSequence("");
            setIttName("");
            setIttDrumAssignment("");

            setMrpProductType("");
            setMrpSlNo("");
            setMrpProcessInput("");
            setMrpSubProcessInput("");

            setIdCreationModule("");
            setIdCreationPrefix("");

            setFileSizeModule("");
            setFileSizeMaxKb("");

            setRfqValidityModule("");
            setRfqValidityReviewType("");
            setRfqValidityDays("");

            setModuleProcessModule("");
            setModuleProcessProcess("");
            setModuleProcessSubProcess("");
            setGrSelSameProductionOrder(false);
            setGrSelSameProductCode(false);
            setGrSelSameWorkcenter(true);
            setGrSelMaxProductionOrders("");
            setIvFields(IV_DEFAULT_FIELDS);
            setSealSignUsername("");
            setSealSignFile(null);


            fetchData(currentType);

        } catch (err) {
            console.error("Save failed:", err.response?.data || err.message || err);
            if (err.response && err.response.data && err.response.data.error) {
                // Surface the real backend error (validation, duplicate, DB error, etc.)
                showToast(err.response.data.error, "error");
            } else {
                showToast("Something went wrong", "error");
            }
        }
    };

    // const handleEdit = (item) => {
    //     setInputValue(item.name);
    //     setEditingId(item.id);
    // };
    const handleEdit = (item) => {
        setEditingId(item.id);

        // STORAGE LOCATION

        if (currentType === "Storage Location") {

            setStorageCode(item.storage_code);
            setStorageLocation(item.storage_location);

            setSelectedProductType({
                value: item.product_type_id,
                label: item.product_type_name,
                id: item.product_type_id,
                name: item.product_type_name
            });

            setSelectedDepartment({
                value: item.department_id,
                label: item.department_name,
                id: item.department_id,
                name: item.department_name
            });
        }

        // PROCESS

        else if (currentType === "Process") {

            setOperationId(item.operation_id);
            setProcessName(item.name);

        }

        else if (currentType === "Sub Process") {

            setSubProcessName(item.name);

            setSubProcessOperationId(
                item.operation_id
            );
            setSubProcessProcessId(
                item.process_id
            );

            setProcessName(
                item.process_name
            );

        }


        else if (currentType === "Workcenter Config") {

            setWorkcenterConfigProcessId(
                item.process_id || ""
            );

            setWorkcenterConfigProcessName(
                item.process_name || ""
            );

            setWorkcenterConfigSubProcessId(
                item.sub_process_id || ""
            );

            setWorkcenterConfigSubProcessName(
                item.sub_process_name || ""
            );

            setWorkcenterConfigName(
                item.workcenter_name || ""
            );

            setWorkcenterConfigDescription(
                item.workcenter_description || ""
            );

        }

        else if (currentType === "Module Process Config") {

            setModuleProcessModule(item.module_name || "");
            setModuleProcessProcess(item.process_name || "");
            setModuleProcessSubProcess(item.sub_process_name || "");

        }

        else if (currentType === "Process Configuration") {

            setProcessId(item.process_id || "");
            setProcessNameConfig(item.process_name || "");

            setSubProcessId(item.sub_process_id || "");
            setSubProcessNameConfig(item.sub_process_name || "");

            setProcessConfigLocation(item.location || "");

            setGroupIdConfig(item.group_id || "");
            setGroupNameConfig(item.group_name || "");

            setWorkcenterNameConfig(item.workcenter_name || "");
            setWorkcenterDescriptionConfig(item.workcenter_description || "");
            setSampleRequirementConfig(item.sample_requirement || "");
        }
        else if (currentType === "HSN Code") {

            setHsnCode(item.hsn_code);
            setCgst(String(item.cgst || ""));
            setSgst(String(item.sgst || ""));
            setIgst(String(item.igst || ""));

        }

        else if (currentType === "Company Code") {

            setCompanyCodeName(item.company_name);
            setCompanyCode(item.company_code);

        }

        else if (currentType === "Customer Rejection Reason") {

            setRejectionReason(item.reason || "");

        }

        else if (currentType === "Country") {

            setCountryName(item.name || "");
            setCountryCurrencyId(item.currency_id || "");
            setCountryCurrencyName(item.currency || "");

        }

        else if (currentType === "Machine Config") {

            setWorkcenterName(item.machine_name);
            setWorkcenterDescription(item.machine_description);

        }

        else if (currentType === "Inspection Test Type") {
            setIttProductType(item.product_type || "");
            setIttSequence(item.sequence || "");
            setIttName(item.name || "");
            setIttDrumAssignment(item.drum_assignment || "");
        }

        else if (currentType === "MRP Sequence") {
            setMrpProductType(item.product_type || "");
            setMrpSlNo(item.sl_no ?? "");
            setMrpProcessInput(
                item.process_id
                    ? `${item.process_id}-${item.process_name || ""}`
                    : (item.process_name || "")
            );
            setMrpSubProcessInput(
                item.sub_process_id
                    ? `${item.sub_process_id}-${item.sub_process_name || ""}`
                    : (item.sub_process_name || "")
            );
        }

        else if (currentType === "Number Range") {
            setIdCreationModule(item.module_name || "");
            setIdCreationPrefix(item.prefix || "");
        }

        else if (currentType === "File Size Config") {
            setFileSizeModule(item.module_name || "");
            setFileSizeMaxKb(item.max_size_kb ?? "");
        }

        else if (currentType === "RFQ Validity") {
            setRfqValidityModule(item.module_name || "");
            setRfqValidityReviewType(item.review_type || "");
            setRfqValidityDays(item.validity_days ?? "");
        }

        else if (currentType === "Tax Configuration") {
            setTaxCountry(item.country || "");
            setTaxMovementType(item.movement_type || "");
            setTaxType(item.tax_type || "");
        }

        else if (currentType === "GL Code") {
            setGlCodeCategory(item.gl_category || "");
            setGlCodeType(item.gl_type || "");
            setGlCode(item.gl_code || "");
        }

        else if (currentType === "Scrap Configuration") {
            setScrapProcessId(item.process_id ? String(item.process_id) : "");
            setScrapName(item.scrap_name || "");
        }

        else if (currentType === "Import Validation Rule") {
            setIvFields(Array.isArray(item.required_fields) ? item.required_fields : []);
        }

        else if (currentType === "Goods Request Selection Rule") {
            setGrSelSameProductionOrder(!!item.same_production_order);
            setGrSelSameProductCode(!!item.same_product_code);
            setGrSelSameWorkcenter(!!item.same_workcenter);
            setGrSelMaxProductionOrders(item.max_production_orders ? String(item.max_production_orders) : "");
        }

        else if (currentType === "Percentage") {
            setPercentageValue(item.percent ?? "");
        }

        else if (currentType === "Seal & Sign") {
            setSealSignUsername(item.username || "");
            setSealSignFile(null); // leave blank — only overwrite if a new file is chosen
        }

        else if (currentType === "Currency") {

            setInputValue(item.name || "");
            setCurrencyCode(item.currency_code || "");
            setCurrencySymbol(item.currency_symbol || "");

        }

        else if (currentType === "Business Partner Responsible") {

            setInputValue(item.name || "");
            setPersonPhone(item.phone_number || "");
            setPersonEmail(item.email || "");

        }

        else if (currentType === "Product Type") {

            setInputValue(item.name || "");

            const usageValues = (item.usage_type || "")
                .split(",")
                .map(v => v.trim())
                .filter(Boolean);

            setProductTypeUsage(
                usageValues.map(v => ({ value: v, label: v }))
            );

        }

        // EXISTING CONFIGURATION

        else {

            setInputValue(item.name);

        }

    };

    //  STYLES 
    const btn = {
        backgroundColor: "  #031b4e",
        color: "#fff",
        border: "none",
        padding: "6px 12px",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "13px"
    };

    const th = {
        padding: "10px",
        borderBottom: "1px solid #e2e8f0",
        textAlign: "left"
    };

    const td = {
        padding: "10px",
        borderBottom: "1px solid #f1f5f9",
        whiteSpace: "nowrap"
    };

    const getColumnCount = () => {

        if (currentType === "Process Configuration")
            return 9;

        if (currentType === "Workcenter Config")
            return 8;

        if (currentType === "Module Process Config")
            return 3;

        if (currentType === "HSN Code")
            return 6;

        if (currentType === "Company Code")
            return 4;

        if (currentType === "Customer Rejection Reason")
            return 3;

        if (currentType === "Storage Location")
            return 6;

        if (currentType === "Sub Process")
            return 5;

        if (currentType === "Process")
            return 4;

        if (currentType === "Machine Config")
            return 4;

        if (currentType === "Inspection Test Type")
            return 6;

        if (currentType === "MRP Sequence")
            return 6;

        if (currentType === "Number Range")
            return 3;

        if (currentType === "File Size Config")
            return 3;

        if (currentType === "RFQ Validity")
            return 3;

        if (currentType === "Tax Configuration")
            return 3;

        if (currentType === "GL Code")
            return 3;

        if (currentType === "Scrap Configuration")
            return 2;

        if (currentType === "Import Validation Rule")
            return 1;

        if (currentType === "Goods Request Selection Rule")
            return 4;

        if (currentType === "Percentage")
            return 1;

        if (currentType === "Product Type")
            return 3;

        if (currentType === "Business Partner Responsible")
            return 4;

        return 3;
    };

    const getModalWidth = () => {

        const columns = getColumnCount();

        // HSN screen size as baseline
        const baseWidth = 1200;

        const ideal = Math.max(baseWidth, columns * 220);

        // Never force the modal wider than the viewport allows — on narrow
        // screens (mobile, split-screen, DevTools open) it falls back to 96vw
        // and the table inside scrolls horizontally instead.
        return `min(${ideal}px, 96vw)`;
    };

    const filteredModalData = data.filter((item) => {
        if (!modalSearchTerm) return true;
        const term = modalSearchTerm.toLowerCase();

        if (currentType === "Machine Config") {
            return (
                (item.machine_name || "").toLowerCase().includes(term) ||
                (item.machine_description || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "HSN Code") {
            return (item.hsn_code || "").toString().toLowerCase().includes(term);
        }
        if (currentType === "Company Code") {
            return (
                (item.company_name || "").toLowerCase().includes(term) ||
                (item.company_code || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Customer Rejection Reason") {
            return (item.reason || "").toLowerCase().includes(term);
        }
        if (currentType === "Inspection Test Type") {
            return (
                (item.product_type || "").toLowerCase().includes(term) ||
                (item.name || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "MRP Sequence") {
            return (
                (item.product_type || "").toLowerCase().includes(term) ||
                (item.process_name || "").toLowerCase().includes(term) ||
                (item.sub_process_name || "").toLowerCase().includes(term) ||
                String(item.sl_no || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Storage Location") {
            return (
                (item.product_type_name || "").toLowerCase().includes(term) ||
                (item.department_name || "").toLowerCase().includes(term) ||
                (item.storage_code || "").toLowerCase().includes(term) ||
                (item.storage_location || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Process") {
            return (
                (item.operation_id || "").toLowerCase().includes(term) ||
                (item.name || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Number Range") {
            return (
                (item.module_name || "").toLowerCase().includes(term) ||
                (item.prefix || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "File Size Config") {
            return (
                (item.module_name || "").toLowerCase().includes(term) ||
                String(item.max_size_kb || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "RFQ Validity") {
            return (
                (item.module_name || "").toLowerCase().includes(term) ||
                (item.review_type || "").toLowerCase().includes(term) ||
                String(item.validity_days || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Tax Configuration") {
            return (
                (item.country || "").toLowerCase().includes(term) ||
                (item.movement_type || "").toLowerCase().includes(term) ||
                (item.tax_type || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Scrap Configuration") {
            return (
                (item.process_name || "").toLowerCase().includes(term) ||
                (item.scrap_name || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Import Validation Rule") {
            return [
                ...IV_FIELD_OPTIONS
                    .filter(o => (item.required_fields || []).includes(o.key))
                    .map(o => o.label.toLowerCase())
            ].join(" ").includes(term);
        }
        if (currentType === "Goods Request Selection Rule") {
            return [
                item.same_production_order ? "production order number" : "",
                item.same_product_code ? "product code" : "",
                item.same_workcenter ? "workcenter" : "",
                item.max_production_orders ? `max production orders ${item.max_production_orders}` : "no limit"
            ].join(" ").includes(term);
        }
        if (currentType === "Percentage") {
            return String(item.percent ?? "").toLowerCase().includes(term);
        }
        if (currentType === "Seal & Sign") {
            return (item.username || "").toLowerCase().includes(term);
        }
        if (currentType === "Sub Process") {
            return (
                (item.operation_id || "").toLowerCase().includes(term) ||
                (item.process_name || "").toLowerCase().includes(term) ||
                (item.name || "").toLowerCase().includes(term)
            );
        }
        if (currentType === "Process Configuration" || currentType === "Workcenter Config") {
            return (
                (item.process_id || "").toString().toLowerCase().includes(term) ||
                (item.process_name || "").toLowerCase().includes(term) ||
                (item.sub_process_id || "").toString().toLowerCase().includes(term) ||
                (item.sub_process_name || "").toLowerCase().includes(term) ||
                (item.location || "").toLowerCase().includes(term) ||
                (item.workcenter_name || "").toLowerCase().includes(term) ||
                (item.workcenter_description || "").toLowerCase().includes(term)
            );
        }

        if (currentType === "Module Process Config") {
            return (
                (item.module_name || "").toLowerCase().includes(term) ||
                (item.process_name || "").toLowerCase().includes(term) ||
                (item.sub_process_name || "").toLowerCase().includes(term)
            );
        }

        if (currentType === "Currency") {
            return (
                (item.name || "").toLowerCase().includes(term) ||
                (item.currency_code || "").toLowerCase().includes(term) ||
                (item.currency_symbol || "").toLowerCase().includes(term)
            );
        }

        if (currentType === "Business Partner Responsible") {
            return (
                (item.name || "").toLowerCase().includes(term) ||
                (item.phone_number || "").toLowerCase().includes(term) ||
                (item.email || "").toLowerCase().includes(term)
            );
        }

        if (currentType === "Product Type") {
            return (
                (item.name || "").toLowerCase().includes(term) ||
                (item.usage_type || "").toLowerCase().includes(term)
            );
        }

        // fallback for simple name-only types
        return (item.name || "").toLowerCase().includes(term);
    });

    return (
        <Layout>
            <div style={{
                padding: "24px 16px",
                backgroundColor: "#f8fafc",
                minHeight: "calc(100vh - 60px)",
                boxSizing: "border-box",
                width: "100%",
                overflowX: "hidden"
            }}>

                {/* HEADER */}
                <div style={{ marginBottom: "30px" }}>
                    <h2 style={{
                        margin: "0 0 8px 0",
                        color: "#0f172a",
                        fontWeight: "700",
                        fontSize: "28px"
                    }}>
                        CableNXT Configuration
                    </h2>

                    <p style={{
                        color: "#64748b",
                        margin: 0,
                        fontSize: "15px"
                    }}>
                        Manage and maintain product master information.
                    </p>
                </div>

                {/* MAIN CONTAINER */}
                {/* MASTER TABLE */}
                <div
                    style={{
                        background: "#fff",
                        borderRadius: "14px",
                        border: "1px solid #e2e8f0",
                        overflow: "hidden",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                    }}
                >

                    {/* SEARCH BAR */}

                    <div
                        style={{
                            padding: "18px",
                            borderBottom: "1px solid #e2e8f0",
                            background: "#f8fafc"
                        }}
                    >

                        <input
                            type="text"
                            placeholder="Search Feature..."
                            value={searchTerm}
                            onChange={(e) =>
                                setSearchTerm(
                                    e.target.value
                                )
                            }
                            style={{
                                width: "100%",
                                maxWidth: "320px",
                                boxSizing: "border-box",
                                padding: "11px 14px",
                                borderRadius: "8px",
                                border: "1px solid #cbd5e1",
                                outline: "none",
                                fontSize: "14px",
                                background: "#fff"
                            }}
                        />

                    </div>

                    <div style={{ overflowX: "auto" }}>
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "14px"
                            }}
                        >

                            {/* TABLE HEADER */}

                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1
                                }}
                            >

                                <tr
                                    style={{
                                        background: "#f8fafc",
                                        borderBottom:
                                            "1px solid #e2e8f0"
                                    }}
                                >

                                    <th style={th}>
                                        Sl No
                                    </th>

                                    <th style={th}>
                                        Feature
                                    </th>

                                    <th style={th}>
                                        Description
                                    </th>

                                    <th style={th}>

                                    </th>

                                </tr>

                            </thead>

                            {/* TABLE BODY */}

                            <tbody>

                                {sections
                                    .filter((sec) =>
                                        sec
                                            .toLowerCase()
                                            .includes(
                                                searchTerm.toLowerCase()
                                            )
                                    )
                                    .map((sec, i) => (

                                        <tr
                                            key={i}
                                            style={{
                                                background:
                                                    i % 2 === 0
                                                        ? "#fff"
                                                        : "#fcfcfc",
                                                transition: "0.2s"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background =
                                                    "#f8fafc";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background =
                                                    i % 2 === 0
                                                        ? "#fff"
                                                        : "#fcfcfc";
                                            }}
                                        >

                                            {/* SR NO */}

                                            <td style={td}>
                                                {i + 1}
                                            </td>

                                            {/* FEATURE */}

                                            <td
                                                style={{
                                                    ...td,
                                                    fontWeight: 600,
                                                    color: "#0f172a"
                                                }}
                                            >
                                                {sec}
                                            </td>

                                            {/* DESCRIPTION */}

                                            <td
                                                style={{
                                                    ...td,
                                                    color: "#64748b"
                                                }}
                                            >
                                                Manage {sec} master data
                                            </td>

                                            {/* ACTIONS */}

                                            <td style={td}>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "10px"
                                                    }}
                                                >

                                                    {/* ADD BUTTON */}

                                                    <button
                                                        style={{
                                                            ...btn,
                                                            minWidth: "90px"
                                                        }}
                                                        onClick={() => {

                                                            if (!canCreate) {

                                                                showToast(
                                                                    "You don't have Create access. Please contact admin.",
                                                                    "error"
                                                                );

                                                                return;
                                                            }

                                                            openModal(
                                                                sec,
                                                                "add"
                                                            );

                                                        }}
                                                    >
                                                        + Add
                                                    </button>

                                                    {/* VIEW BUTTON */}

                                                    <button
                                                        style={{
                                                            ...btn,
                                                            background:
                                                                "#fff",
                                                            color:
                                                                "#031b4e",
                                                            border:
                                                                "1px solid #031b4e",
                                                            minWidth:
                                                                "90px"
                                                        }}
                                                        onClick={() => {

                                                            if (!canView) {

                                                                showToast(
                                                                    "You don't have View access. Please contact admin.",
                                                                    "error"
                                                                );

                                                                return;
                                                            }

                                                            openModal(
                                                                sec,
                                                                "view"
                                                            );

                                                        }}
                                                    >
                                                        View
                                                    </button>

                                                </div>

                                            </td>

                                        </tr>

                                    ))}

                                {/* EMPTY STATE */}

                                {sections.filter((sec) =>
                                    sec
                                        .toLowerCase()
                                        .includes(
                                            searchTerm.toLowerCase()
                                        )
                                ).length === 0 && (

                                        <tr>

                                            <td
                                                colSpan={4}
                                                style={{
                                                    padding: "30px",
                                                    textAlign: "center",
                                                    color: "#94a3b8",
                                                    fontSize: "14px"
                                                }}
                                            >
                                                No matching features found
                                            </td>

                                        </tr>

                                    )}

                            </tbody>

                        </table>
                    </div>

                </div>

                {/* MODAL */}
                {showModal && (
                    <div style={overlay}>

                        <div
                            style={{
                                ...modal,
                                maxWidth: getModalWidth()
                            }}
                        >

                            {/* HEADER */}
                            <div style={{ padding: "20px", borderBottom: "1px solid #e2e8f0" }}>
                                <h4>{currentType}</h4>
                            </div>

                            {/* INPUT SECTION */}
                            {mode === "add" && (
                                <div style={{ padding: "15px 20px" }}>

                                    {currentType === "Storage Location" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <Select
                                                isClearable
                                                isSearchable
                                                placeholder="Select Product Type"
                                                value={selectedProductType}
                                                options={productTypes.map(item => ({
                                                    value: item.id,
                                                    label: item.name,
                                                    id: item.id,
                                                    name: item.name
                                                }))}
                                                onChange={setSelectedProductType}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    container: (base) => ({
                                                        ...base,
                                                        flex: 1,
                                                        minWidth: "220px"
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 99999
                                                    })
                                                }}
                                            />

                                            <Select
                                                isClearable
                                                isSearchable
                                                placeholder="Select Department"
                                                value={selectedDepartment}
                                                options={departments.map(item => ({
                                                    value: item.id,
                                                    label: item.name,
                                                    id: item.id,
                                                    name: item.name
                                                }))}
                                                onChange={setSelectedDepartment}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    container: (base) => ({
                                                        ...base,
                                                        flex: 1,
                                                        minWidth: "220px"
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 99999
                                                    })
                                                }}
                                            />

                                            <input
                                                value={storageCode}
                                                onChange={(e) =>
                                                    setStorageCode(e.target.value)
                                                }
                                                placeholder="Storage Code"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                value={storageLocation}
                                                onChange={(e) =>
                                                    setStorageLocation(e.target.value)
                                                }
                                                placeholder="Storage Location"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>

                                    ) : currentType === "Process" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={operationId}
                                                onChange={(e) => {

                                                    const value = e.target.value;

                                                    setOperationId(value);

                                                    if (
                                                        value.length >= 2 ||
                                                        value.length === 0
                                                    ) {

                                                        fetchData(
                                                            currentType,
                                                            value
                                                        );

                                                    }

                                                }}
                                                placeholder="Enter Operation ID"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                value={processName}
                                                onChange={(e) => {

                                                    const value = e.target.value;

                                                    setProcessName(value);

                                                    if (
                                                        value.length >= 2 ||
                                                        value.length === 0
                                                    ) {

                                                        fetchData(
                                                            currentType,
                                                            value
                                                        );

                                                    }

                                                }}
                                                placeholder="Enter Process"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>

                                    ) : currentType === "Sub Process" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            {/* OPERATION ID */}

                                            <select
                                                value={subProcessOperationId}
                                                onChange={(e) => {

                                                    const selectedOperationId =
                                                        e.target.value;

                                                    const selectedProcess =
                                                        processMaster.find(
                                                            (p) =>
                                                                p.operation_id ===
                                                                selectedOperationId
                                                        );

                                                    setSubProcessOperationId(
                                                        selectedOperationId
                                                    );

                                                    setSubProcessProcessId(
                                                        selectedProcess?.id || ""
                                                    );

                                                    setProcessName(
                                                        selectedProcess?.name || ""
                                                    );

                                                }}
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            >

                                                <option value="">
                                                    Select Operation ID
                                                </option>

                                                {processMaster.map((p) => (

                                                    <option
                                                        key={p.id}
                                                        value={p.operation_id}
                                                    >
                                                        {p.operation_id}
                                                    </option>

                                                ))}

                                            </select>

                                            {/* PROCESS */}

                                            <select
                                                value={processName}
                                                onChange={(e) => {

                                                    const selectedProcessName =
                                                        e.target.value;

                                                    const selectedProcess =
                                                        processMaster.find(
                                                            (p) =>
                                                                p.name ===
                                                                selectedProcessName
                                                        );

                                                    setProcessName(
                                                        selectedProcessName
                                                    );

                                                    setSubProcessOperationId(
                                                        selectedProcess?.operation_id || ""
                                                    );

                                                    setSubProcessProcessId(
                                                        selectedProcess?.id || ""
                                                    );

                                                }}
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            >

                                                <option value="">
                                                    Select Process
                                                </option>

                                                {processMaster.map((p) => (

                                                    <option
                                                        key={p.id}
                                                        value={p.name}
                                                    >
                                                        {p.name}
                                                    </option>

                                                ))}

                                            </select>

                                            {/* SUB PROCESS */}

                                            <input
                                                value={subProcessName}
                                                onChange={(e) =>
                                                    setSubProcessName(
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="Enter Sub Process"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>


                                    ) : currentType === "Process Configuration" ? (

                                        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>

                                            {/* ROW 1 — LOCATION ALONE */}
                                            <div style={{ display: "flex" }}>
                                                <select
                                                    value={processConfigLocation}
                                                    onChange={(e) => setProcessConfigLocation(e.target.value)}
                                                    style={{ ...input, width: "160px", margin: 0 }}
                                                >
                                                    <option value="">Select Location</option>
                                                    {locationMaster.map(l => (
                                                        <option key={l.id} value={l.name}>{l.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* ROW 2 — EVERYTHING ELSE */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "12px",
                                                    alignItems: "center",
                                                    flexWrap: "wrap"
                                                }}
                                            >

                                                <input
                                                    value={processId}
                                                    onChange={(e) => setProcessId(e.target.value)}
                                                    placeholder="Enter Process ID"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <input
                                                    value={processNameConfig}
                                                    onChange={(e) => setProcessNameConfig(e.target.value)}
                                                    placeholder="Enter Process Name"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <input
                                                    value={subProcessId}
                                                    onChange={(e) => setSubProcessId(e.target.value)}
                                                    placeholder="Enter Sub Process ID"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <input
                                                    value={subProcessNameConfig}
                                                    onChange={(e) => setSubProcessNameConfig(e.target.value)}
                                                    placeholder="Enter Sub Process Name"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <input
                                                    value={groupIdConfig}
                                                    onChange={(e) => setGroupIdConfig(e.target.value)}
                                                    placeholder="Enter Group ID"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <input
                                                    value={groupNameConfig}
                                                    onChange={(e) => setGroupNameConfig(e.target.value)}
                                                    placeholder="Enter Group Name"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <select
                                                    value={workcenterNameConfig}
                                                    onChange={(e) => {

                                                        const selected =
                                                            workcenterMaster.find(
                                                                w => w.workcenter_name === e.target.value
                                                            );

                                                        setWorkcenterNameConfig(
                                                            selected?.workcenter_name || ""
                                                        );

                                                        setWorkcenterDescriptionConfig(
                                                            selected?.workcenter_description || ""
                                                        );

                                                    }}
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                >
                                                    <option value="">
                                                        Select Workcenter
                                                    </option>

                                                    {workcenterMaster.map(w => (
                                                        <option
                                                            key={w.id}
                                                            value={w.workcenter_name}
                                                        >
                                                            {w.workcenter_name}
                                                        </option>
                                                    ))}
                                                </select>

                                                <input
                                                    value={workcenterDescriptionConfig}
                                                    readOnly
                                                    placeholder="Workcenter Description"
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                />

                                                <select
                                                    value={sampleRequirementConfig}
                                                    onChange={(e) =>
                                                        setSampleRequirementConfig(e.target.value)
                                                    }
                                                    style={{ ...input, flex: 1, margin: 0 }}
                                                >
                                                    <option value="">Sample Requirement</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>

                                            </div>

                                        </div>

                                    ) : currentType === "Workcenter Config" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <select
                                                value={workcenterConfigProcessId}
                                                onChange={(e) => {

                                                    const selected =
                                                        processSubProcessData.find(
                                                            p => p.process_id === e.target.value
                                                        );

                                                    setWorkcenterConfigProcessId(
                                                        selected?.process_id || ""
                                                    );

                                                    setWorkcenterConfigProcessName(
                                                        selected?.process_name || ""
                                                    );

                                                    setWorkcenterConfigSubProcessId("");
                                                    setWorkcenterConfigSubProcessName("");
                                                }}
                                                style={{ ...input, flex: 1 }}
                                            >
                                                <option value="">
                                                    Select Process
                                                </option>

                                                {[
                                                    ...new Map(
                                                        processSubProcessData.map(
                                                            item => [item.process_id, item]
                                                        )
                                                    ).values()
                                                ].map(item => (

                                                    <option
                                                        key={item.process_id}
                                                        value={item.process_id}
                                                    >
                                                        {item.process_id} - {item.process_name}
                                                    </option>

                                                ))}
                                            </select>

                                            <input
                                                value={workcenterConfigProcessName}
                                                readOnly
                                                placeholder="Process Name"
                                                style={{ ...input, flex: 1 }}
                                            />

                                            <select
                                                value={workcenterConfigSubProcessId}
                                                onChange={(e) => {

                                                    const selected =
                                                        processSubProcessData.find(
                                                            p =>
                                                                p.process_id ===
                                                                workcenterConfigProcessId &&
                                                                p.sub_process_id ===
                                                                e.target.value
                                                        );

                                                    setWorkcenterConfigSubProcessId(
                                                        selected?.sub_process_id || ""
                                                    );

                                                    setWorkcenterConfigSubProcessName(
                                                        selected?.sub_process_name || ""
                                                    );

                                                }}
                                                style={{ ...input, flex: 1 }}
                                            >
                                                <option value="">
                                                    Select Sub Process
                                                </option>

                                                {processSubProcessData
                                                    .filter(
                                                        p =>
                                                            p.process_id ===
                                                            workcenterConfigProcessId
                                                    )
                                                    .map(item => (

                                                        <option
                                                            key={item.id}
                                                            value={item.sub_process_id}
                                                        >
                                                            {item.sub_process_id} -
                                                            {item.sub_process_name}
                                                        </option>

                                                    ))}
                                            </select>

                                            <input
                                                value={workcenterConfigSubProcessName}
                                                readOnly
                                                placeholder="Sub Process Name"
                                                style={{ ...input, flex: 1 }}
                                            />

                                            <select
                                                value={workcenterConfigName}
                                                onChange={(e) => {

                                                    const selected = workcenterMaster.find(
                                                        w => w.workcenter_name === e.target.value
                                                    );

                                                    console.log("SELECTED WORKCENTER", selected);

                                                    setWorkcenterConfigName(
                                                        selected?.workcenter_name || ""
                                                    );

                                                    setWorkcenterConfigDescription(
                                                        selected?.workcenter_description || ""
                                                    );

                                                }}
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    minWidth: "250px",
                                                    maxWidth: "300px"
                                                }}
                                            >
                                                <option value="">
                                                    Select Workcenter
                                                </option>

                                                {Array.isArray(workcenterMaster) &&
                                                    workcenterMaster.map(w => (

                                                        <option
                                                            key={w.id}
                                                            value={w.workcenter_name}
                                                        >
                                                            {w.workcenter_name}
                                                        </option>

                                                    ))}
                                            </select>

                                            <input
                                                value={workcenterConfigDescription}
                                                readOnly
                                                placeholder="Workcenter Description"
                                                style={{ ...input, flex: 1 }}
                                            />

                                        </div>


                                    ) : currentType === "Module Process Config" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={moduleProcessModule}
                                                onChange={(e) => setModuleProcessModule(e.target.value)}
                                                placeholder="Module"
                                                style={{ ...input, flex: 1 }}
                                            />

                                            <input
                                                value={moduleProcessProcess}
                                                onChange={(e) => setModuleProcessProcess(e.target.value)}
                                                placeholder="Process"
                                                style={{ ...input, flex: 1 }}
                                            />

                                            <input
                                                value={moduleProcessSubProcess}
                                                onChange={(e) => setModuleProcessSubProcess(e.target.value)}
                                                placeholder="Sub Process"
                                                style={{ ...input, flex: 1 }}
                                            />

                                        </div>

                                    ) : currentType === "HSN Code" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={hsnCode}
                                                onChange={(e) =>
                                                    setHsnCode(e.target.value)
                                                }
                                                placeholder="HSN Code"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                type="number"
                                                step="0.01"
                                                value={cgst}
                                                onChange={(e) =>
                                                    setCgst(e.target.value)
                                                }
                                                placeholder="CGST"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                type="number"
                                                step="0.01"
                                                value={sgst}
                                                onChange={(e) =>
                                                    setSgst(e.target.value)
                                                }
                                                placeholder="SGST"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                type="number"
                                                step="0.01"
                                                value={igst}
                                                onChange={(e) =>
                                                    setIgst(e.target.value)
                                                }
                                                placeholder="IGST"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>

                                    ) : currentType === "Company Code" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={companyCodeName}
                                                onChange={(e) =>
                                                    setCompanyCodeName(e.target.value)
                                                }
                                                placeholder="Company Name"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                value={companyCode}
                                                onChange={(e) =>
                                                    setCompanyCode(e.target.value)
                                                }
                                                placeholder="Company Code"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>

                                    ) : currentType === "Customer Rejection Reason" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={rejectionReason}
                                                onChange={(e) =>
                                                    setRejectionReason(e.target.value)
                                                }
                                                placeholder="Rejection Reason"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>

                                    ) : currentType === "Country" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={countryName}
                                                onChange={(e) =>
                                                    setCountryName(e.target.value)
                                                }
                                                placeholder="Country Name"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    placeholder="Select Currency"
                                                    options={currencyMaster.map((c) => ({
                                                        value: c.id,
                                                        label: c.name
                                                    }))}
                                                    value={
                                                        countryCurrencyId
                                                            ? { value: countryCurrencyId, label: countryCurrencyName }
                                                            : null
                                                    }
                                                    onChange={(opt) => {
                                                        setCountryCurrencyId(opt?.value || "");
                                                        setCountryCurrencyName(opt?.label || "");
                                                    }}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                                />
                                            </div>

                                        </div>

                                    ) : currentType === "Machine Config" ? (

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "12px",
                                                alignItems: "center",
                                                flexWrap: "wrap"
                                            }}
                                        >

                                            <input
                                                value={workcenterName}
                                                onChange={(e) =>
                                                    setWorkcenterName(e.target.value)
                                                }
                                                placeholder="Enter Machine Name"

                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                            <input
                                                value={workcenterDescription}
                                                onChange={(e) =>
                                                    setWorkcenterDescription(e.target.value)
                                                }
                                                placeholder="Enter Description"
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0
                                                }}
                                            />

                                        </div>

                                    ) : currentType === "Inspection Test Type" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={ittProductType}
                                                onChange={(e) => setIttProductType(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Product Type --</option>
                                                {productTypes.map(pt => (
                                                    <option key={pt.id} value={pt.name}>{pt.name}</option>
                                                ))}
                                            </select>

                                            <input
                                                type="number"
                                                value={ittSequence}
                                                onChange={(e) => setIttSequence(e.target.value)}
                                                placeholder="Sequence"
                                                style={{ ...input, flex: 0.5, margin: 0 }}
                                            />

                                            <input
                                                type="text"
                                                value={ittName}
                                                onChange={(e) => setIttName(e.target.value)}
                                                placeholder="Inspection Test Type Name"
                                                style={{ ...input, flex: 2, margin: 0 }}
                                            />

                                            <select
                                                value={ittDrumAssignment}
                                                onChange={(e) => setIttDrumAssignment(e.target.value)}
                                                disabled={ittProductType?.trim().toUpperCase() !== "FINISHED GOODS"}
                                                style={{
                                                    ...input,
                                                    flex: 1,
                                                    margin: 0,
                                                    backgroundColor:
                                                        ittProductType?.trim().toUpperCase() === "FINISHED GOODS"
                                                            ? "#fff"
                                                            : "#f1f5f9"
                                                }}
                                            >
                                                <option value="">-- Drum Assignment --</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>

                                        </div>

                                    ) : currentType === "MRP Sequence" ? (

                                        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>

                                            <select
                                                value={mrpProductType}
                                                onChange={(e) => setMrpProductType(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Product Type --</option>
                                                {productTypes.map(pt => (
                                                    <option key={pt.id} value={pt.name}>{pt.name}</option>
                                                ))}
                                            </select>

                                            <input
                                                type="number"
                                                value={mrpSlNo}
                                                onChange={(e) => setMrpSlNo(e.target.value)}
                                                placeholder="Sl No"
                                                style={{ ...input, flex: 0.5, margin: 0 }}
                                            />

                                            <input
                                                value={mrpProcessInput}
                                                onChange={(e) => setMrpProcessInput(e.target.value)}
                                                placeholder="e.g. 8125-Process Name"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                            <input
                                                value={mrpSubProcessInput}
                                                onChange={(e) => setMrpSubProcessInput(e.target.value)}
                                                placeholder="e.g. 8125-Sub Process Name"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Number Range" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={idCreationModule}
                                                onChange={(e) => setIdCreationModule(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select Module --</option>
                                                {modulesList.map(m => (
                                                    <option key={m.id} value={m.name}>{m.name}</option>
                                                ))}
                                            </select>

                                            <input
                                                value={idCreationPrefix}
                                                onChange={(e) => setIdCreationPrefix(e.target.value.toUpperCase())}
                                                placeholder="Prefix (e.g. AQ, WN)"
                                                maxLength={10}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "File Size Config" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={fileSizeModule}
                                                onChange={(e) => setFileSizeModule(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select Module --</option>
                                                {modulesList.map(m => (
                                                    <option key={m.id} value={m.name}>{m.name}</option>
                                                ))}
                                            </select>

                                            <input
                                                type="number"
                                                min="1"
                                                value={fileSizeMaxKb}
                                                onChange={(e) => setFileSizeMaxKb(e.target.value)}
                                                placeholder="Max Size in KB (e.g. 50)"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "RFQ Validity" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={rfqValidityModule}
                                                onChange={(e) => setRfqValidityModule(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select Module --</option>
                                                {modulesList.map(m => (
                                                    <option key={m.id} value={m.name}>{m.name}</option>
                                                ))}
                                            </select>

                                            <select
                                                value={rfqValidityReviewType}
                                                onChange={(e) => setRfqValidityReviewType(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select Type of Review --</option>
                                                {REVIEW_TYPES.map(rt => (
                                                    <option key={rt} value={rt}>{rt}</option>
                                                ))}
                                            </select>

                                            <input
                                                type="number"
                                                min="1"
                                                value={rfqValidityDays}
                                                onChange={(e) => setRfqValidityDays(e.target.value)}
                                                placeholder="Validity in days (e.g. 30)"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Tax Configuration" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={taxCountry}
                                                onChange={(e) => setTaxCountry(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select Country --</option>
                                                {taxCountryList.map(c => (
                                                    <option key={c.id} value={c.name}>{c.name}</option>
                                                ))}
                                            </select>

                                            <select
                                                value={taxMovementType}
                                                onChange={(e) => setTaxMovementType(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select Movement Type --</option>
                                                {taxMovementTypeList.map(m => (
                                                    <option key={m.id} value={m.name}>{m.name}</option>
                                                ))}
                                            </select>

                                            <input
                                                value={taxType}
                                                onChange={(e) => setTaxType(e.target.value)}
                                                placeholder="Enter Tax Type (e.g. CGST)"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "GL Code" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={glCodeCategory}
                                                onChange={(e) => setGlCodeCategory(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select GL Category --</option>
                                                {glCodeCategoryList.map(c => (
                                                    <option key={c.id} value={c.name}>{c.name}</option>
                                                ))}
                                            </select>

                                            <select
                                                value={glCodeType}
                                                onChange={(e) => setGlCodeType(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select GL Type --</option>
                                                {glCodeTypeList.map(t => (
                                                    <option key={t.id} value={t.name}>{t.name}</option>
                                                ))}
                                            </select>

                                            <input
                                                value={glCode}
                                                onChange={(e) => setGlCode(e.target.value)}
                                                placeholder="Enter GL Code"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Scrap Configuration" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <select
                                                value={scrapProcessId}
                                                onChange={(e) => setScrapProcessId(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">
                                                    {scrapProcessLoading
                                                        ? "Loading processes..."
                                                        : scrapProcessOptions.length === 0
                                                            ? "No processes found"
                                                            : "-- Select Process --"}
                                                </option>
                                                {scrapProcessOptions.map(p => (
                                                    <option key={p.id} value={String(p.id)}>{p.label}</option>
                                                ))}
                                            </select>

                                            <input
                                                value={scrapName}
                                                onChange={(e) => setScrapName(e.target.value)}
                                                placeholder="Enter Scrap Name"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Import Validation Rule" ? (

                                        <div>

                                            <div style={{ fontSize: "13px", color: "#475569", marginBottom: "10px" }}>
                                                Tick the columns of the Physical Inventory import sheet that must be filled on every line.
                                                Ticked columns are validated (Product Code and Batch Number must also match the stock).
                                                Columns not ticked are optional, but a value given in the sheet (for example Actual Unit
                                                Price) is still saved to the database. "System ..." columns are only checked for
                                                existing stock, not for new stock lines.
                                            </div>

                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gap: "12px 24px" }}>
                                                {IV_FIELD_OPTIONS.map(opt => (
                                                    <label
                                                        key={opt.key}
                                                        style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px" }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={ivFields.includes(opt.key)}
                                                            onChange={(e) => toggleIvField(opt.key, e.target.checked)}
                                                        />
                                                        {opt.label}
                                                    </label>
                                                ))}
                                            </div>

                                            <div style={{ marginTop: "12px", display: "flex", gap: "16px", fontSize: "13px" }}>
                                                <span
                                                    style={{ color: "#2563eb", cursor: "pointer" }}
                                                    onClick={() => setIvFields(IV_FIELD_OPTIONS.map(o => o.key))}
                                                >
                                                    Select all
                                                </span>
                                                <span
                                                    style={{ color: "#2563eb", cursor: "pointer" }}
                                                    onClick={() => setIvFields([])}
                                                >
                                                    Clear
                                                </span>
                                            </div>

                                        </div>


                                    ) : currentType === "Goods Request Selection Rule" ? (

                                        <div>

                                            <div style={{ fontSize: "13px", color: "#475569", marginBottom: "10px" }}>
                                                Rows ticked together in Goods Request (Active tab) must have the same value
                                                for every option selected below.
                                            </div>

                                            <div style={{ display: "flex", gap: "28px", alignItems: "center", flexWrap: "wrap" }}>
                                                {[
                                                    { label: "Production Order Number", checked: grSelSameProductionOrder, set: setGrSelSameProductionOrder },
                                                    { label: "Product Code", checked: grSelSameProductCode, set: setGrSelSameProductCode },
                                                    { label: "Workcenter", checked: grSelSameWorkcenter, set: setGrSelSameWorkcenter }
                                                ].map(opt => (
                                                    <label
                                                        key={opt.label}
                                                        style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px" }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={opt.checked}
                                                            onChange={(e) => opt.set(e.target.checked)}
                                                        />
                                                        {opt.label}
                                                    </label>
                                                ))}
                                            </div>

                                            <div style={{ marginTop: "16px", display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
                                                <label style={{ fontSize: "14px" }}>Max Production Orders</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    value={grSelMaxProductionOrders}
                                                    onChange={(e) => setGrSelMaxProductionOrders(e.target.value)}
                                                    placeholder="Blank = no limit"
                                                    style={{ ...input, width: "180px", margin: 0 }}
                                                />
                                                <span style={{ fontSize: "12px", color: "#64748b" }}>
                                                    Max number of different Production Order Numbers that can be selected together.
                                                </span>
                                            </div>

                                        </div>

                                    ) : currentType === "Percentage" ? (

                                        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>

                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={percentageValue}
                                                onChange={(e) => setPercentageValue(e.target.value)}
                                                placeholder="Enter Percentage (e.g. 9)"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Seal & Sign" ? (

                                        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>

                                            <select
                                                value={sealSignUsername}
                                                onChange={(e) => setSealSignUsername(e.target.value)}
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            >
                                                <option value="">-- Select User --</option>
                                                {sealSignUserOptions.map((u, idx) => (
                                                    <option key={u.id ?? idx} value={u.user_id}>
                                                        {u.user_id}
                                                    </option>
                                                ))}
                                            </select>

                                            <input
                                                type="file"
                                                accept="image/*,.pdf"
                                                onChange={(e) => setSealSignFile(e.target.files?.[0] || null)}
                                                style={{ ...input, flex: 1, margin: 0, padding: "6px" }}
                                            />

                                        </div>


                                    ) : currentType === "Currency" ? (

                                        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>

                                            <input
                                                value={inputValue}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setInputValue(value);

                                                    if (value.length >= 2 || value.length === 0) {
                                                        fetchData(currentType, value);
                                                    }
                                                }}
                                                placeholder="Enter or Search Currency"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                            <input
                                                value={currencyCode}
                                                onChange={(e) => setCurrencyCode(e.target.value.toUpperCase())}
                                                placeholder="Currency Code (e.g. INR)"
                                                maxLength={10}
                                                style={{ ...input, flex: 1, minWidth: "200px", margin: 0 }}
                                            />

                                            <input
                                                value={currencySymbol}
                                                onChange={(e) => setCurrencySymbol(e.target.value)}
                                                placeholder="Symbol (e.g. ₹, $, €, ¥)"
                                                maxLength={10}
                                                style={{ ...input, flex: 1, minWidth: "160px", margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Business Partner Responsible" ? (

                                        <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>

                                            <input
                                                value={inputValue}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setInputValue(value);

                                                    if (value.length >= 2 || value.length === 0) {
                                                        fetchData(currentType, value);
                                                    }
                                                }}
                                                placeholder={`Enter or Search ${currentType}`}
                                                style={{ ...input, flex: 1, minWidth: "200px", margin: 0 }}
                                            />

                                            <input
                                                type="tel"
                                                value={personPhone}
                                                onChange={(e) => setPersonPhone(e.target.value.replace(/[^0-9+\-\s()]/g, ""))}
                                                placeholder="Phone Number"
                                                maxLength={20}
                                                style={{ ...input, flex: 1, minWidth: "160px", margin: 0 }}
                                            />

                                            <input
                                                type="email"
                                                value={personEmail}
                                                onChange={(e) => setPersonEmail(e.target.value)}
                                                placeholder="Email"
                                                maxLength={150}
                                                style={{ ...input, flex: 1, minWidth: "200px", margin: 0 }}
                                            />

                                        </div>

                                    ) : currentType === "Product Type" ? (

                                        <div style={{
                                            display: "flex", gap: "12px", alignItems: "center",
                                            flexWrap: "wrap"
                                        }}>

                                            <input
                                                value={inputValue}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setInputValue(value);

                                                    if (
                                                        value.length >= 2 ||
                                                        value.length === 0
                                                    ) {
                                                        fetchData(currentType, value);
                                                    }
                                                }}
                                                placeholder="Enter or Search Product Type"
                                                style={{ ...input, flex: 1, margin: 0 }}
                                            />

                                            <Select
                                                isMulti
                                                isSearchable={false}
                                                placeholder="Internal / External"
                                                value={productTypeUsage}
                                                options={PRODUCT_TYPE_USAGE_OPTIONS}
                                                onChange={(selected) => setProductTypeUsage(selected || [])}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    container: (base) => ({
                                                        ...base,
                                                        flex: 1,
                                                        minWidth: "220px"
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 99999
                                                    })
                                                }}
                                            />

                                        </div>

                                    ) : (

                                        <input
                                            value={inputValue}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                setInputValue(value);

                                                if (
                                                    value.length >= 2 ||
                                                    value.length === 0
                                                ) {
                                                    fetchData(currentType, value);
                                                }
                                            }}
                                            placeholder={`Enter or Search ${currentType}`}
                                            style={input}
                                        />

                                    )}

                                    <button
                                        style={{
                                            ...btn,
                                            marginTop: "12px"
                                        }}
                                        onClick={handleSave}
                                    >
                                        {editingId ? "Update" : "Add"}
                                    </button>

                                </div>
                            )}
                            {/* SCROLLABLE TABLE */}
                            <div style={{
                                flex: 1,
                                overflowY: "auto",
                                overflowX: "auto",
                                padding: "0 20px"
                            }}>

                                {mode === "view" && (
                                    <div style={{ padding: "10px 0" }}>
                                        <input
                                            type="text"
                                            placeholder={`Search ${currentType}`}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setModalSearchTerm(value);

                                                //  trigger search
                                                if (value.length >= 2 || value.length === 0) {
                                                    fetchData(currentType, value);
                                                }
                                            }}
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc"
                                            }}
                                        />
                                    </div>
                                )}

                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead style={{
                                        position: "sticky",
                                        top: 0,
                                        background: "#f1f5f9",
                                        zIndex: 1
                                    }}>
                                        <tr>

                                            {currentType === "Storage Location" ? (

                                                <>
                                                    <th style={th}>Product Type</th>
                                                    <th style={th}>Department</th>
                                                    <th style={th}>Storage Code</th>
                                                    <th style={th}>Storage Location</th>
                                                </>

                                            ) : currentType === "Process" ? (

                                                <>
                                                    <th style={th}>Operation ID</th>
                                                    <th style={th}>Process</th>
                                                </>

                                            ) : currentType === "Sub Process" ? (

                                                <>
                                                    <th style={th}>Operation ID</th>
                                                    <th style={th}>Process</th>
                                                    <th style={th}>Sub Process</th>
                                                </>


                                            ) : currentType === "HSN Code" ? (

                                                <>
                                                    <th style={th}>HSN Code</th>
                                                    <th style={th}>CGST</th>
                                                    <th style={th}>SGST</th>
                                                    <th style={th}>IGST</th>
                                                </>

                                            ) : currentType === "Company Code" ? (

                                                <>
                                                    <th style={th}>Company Name</th>
                                                    <th style={th}>Company Code</th>
                                                </>

                                            ) : currentType === "Customer Rejection Reason" ? (

                                                <>
                                                    <th style={th}>Rejection Reason</th>
                                                </>

                                            ) : currentType === "Country" ? (

                                                <>
                                                    <th style={th}>Country Name</th>
                                                    <th style={th}>Currency</th>
                                                </>

                                            ) : currentType === "Machine Config" ? (

                                                <>
                                                    <th style={th}>Machine Name</th>
                                                    <th style={th}>Description</th>
                                                </>
                                            ) : currentType === "Process Configuration" ? (

                                                <>
                                                    <th style={th}>Process ID</th>
                                                    <th style={th}>Process Name</th>
                                                    <th style={th}>Sub Process ID</th>
                                                    <th style={th}>Sub Process Name</th>
                                                    <th style={th}>Location</th>
                                                    <th style={th}>Group ID</th>
                                                    <th style={th}>Group Name</th>
                                                    <th style={th}>Workcenter Name</th>
                                                    <th style={th}>Workcenter Description</th>
                                                    <th style={th}>Sample Requirement</th>
                                                </>



                                            ) : currentType === "Workcenter Config" ? (

                                                <>
                                                    <th style={th}>Process ID</th>
                                                    <th style={th}>Process Name</th>
                                                    <th style={th}>Sub Process ID</th>
                                                    <th style={th}>Sub Process Name</th>
                                                    <th style={th}>Workcenter Name</th>
                                                    <th style={th}>Workcenter Description</th>
                                                </>

                                            ) : currentType === "Module Process Config" ? (

                                                <>
                                                    <th style={th}>Module</th>
                                                    <th style={th}>Process</th>
                                                    <th style={th}>Sub Process</th>
                                                </>

                                            ) : currentType === "Inspection Test Type" ? (

                                                <>
                                                    <th style={th}>Product Type</th>
                                                    <th style={th}>Sequence</th>
                                                    <th style={th}>Inspection Test Type</th>
                                                    <th style={th}>Drum Assignment</th>
                                                </>

                                            ) : currentType === "MRP Sequence" ? (

                                                <>
                                                    <th style={th}>Product Type</th>
                                                    <th style={th}>Sl No</th>
                                                    <th style={th}>Process ID</th>
                                                    <th style={th}>Process Name</th>
                                                    <th style={th}>Sub Process ID</th>
                                                    <th style={th}>Sub Process Name</th>
                                                </>

                                            ) : currentType === "Number Range" ? (

                                                <>
                                                    <th style={th}>Module</th>
                                                    <th style={th}>Prefix</th>
                                                </>

                                            ) : currentType === "File Size Config" ? (

                                                <>
                                                    <th style={th}>Module</th>
                                                    <th style={th}>Max Size (KB)</th>
                                                </>

                                            ) : currentType === "RFQ Validity" ? (

                                                <>
                                                    <th style={th}>Module</th>
                                                    <th style={th}>Type of Review</th>
                                                    <th style={th}>Validity (days)</th>
                                                </>

                                            ) : currentType === "Tax Configuration" ? (

                                                <>
                                                    <th style={th}>Country</th>
                                                    <th style={th}>Movement Type</th>
                                                    <th style={th}>Tax Type</th>
                                                </>

                                            ) : currentType === "GL Code" ? (

                                                <>
                                                    <th style={th}>GL Category</th>
                                                    <th style={th}>GL Type</th>
                                                    <th style={th}>GL Code</th>
                                                </>

                                            ) : currentType === "Scrap Configuration" ? (

                                                <>
                                                    <th style={th}>Process</th>
                                                    <th style={th}>Scrap Name</th>
                                                </>

                                            ) : currentType === "Import Validation Rule" ? (

                                                <>
                                                    <th style={th}>Mandatory Fields</th>
                                                </>


                                            ) : currentType === "Goods Request Selection Rule" ? (

                                                <>
                                                    <th style={th}>Production Order Number</th>
                                                    <th style={th}>Product Code</th>
                                                    <th style={th}>Workcenter</th>
                                                    <th style={th}>Max Production Orders</th>
                                                </>

                                            ) : currentType === "Percentage" ? (

                                                <>
                                                    <th style={th}>Percentage (%)</th>
                                                </>

                                            ) : currentType === "Seal & Sign" ? (

                                                <>
                                                    <th style={th}>User</th>
                                                    <th style={th}>Seal / Sign</th>
                                                </>

                                            ) : currentType === "Currency" ? (

                                                <>
                                                    <th style={th}>Name</th>
                                                    <th style={th}>Currency Code</th>
                                                    <th style={th}>Symbol</th>
                                                </>

                                            ) : currentType === "Business Partner Responsible" ? (

                                                <>
                                                    <th style={th}>Name</th>
                                                    <th style={th}>Phone Number</th>
                                                    <th style={th}>Email</th>
                                                </>

                                            ) : currentType === "Product Type" ? (

                                                <>
                                                    <th style={th}>Name</th>
                                                    <th style={th}>Usage</th>
                                                </>

                                            ) : (

                                                <th style={th}>Name</th>

                                            )}

                                            {mode === "add" && (
                                                <th style={th}> </th>
                                            )}

                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredModalData.map((item, i) => (
                                            <tr key={item.id} style={{
                                                background: i % 2 === 0 ? "#fff" : "#f9fafb"
                                            }}>
                                                {currentType === "Storage Location" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.product_type_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.department_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.storage_code}
                                                        </td>

                                                        <td style={td}>
                                                            {item.storage_location}
                                                        </td>
                                                    </>

                                                ) : currentType === "Sub Process" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.operation_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.process_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.name}
                                                        </td>
                                                    </>

                                                ) : currentType === "Process" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.operation_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.name}
                                                        </td>
                                                    </>
                                                ) : currentType === "HSN Code" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.hsn_code}
                                                        </td>

                                                        <td style={td}>
                                                            {item.cgst}
                                                        </td>

                                                        <td style={td}>
                                                            {item.sgst}
                                                        </td>

                                                        <td style={td}>
                                                            {item.igst}
                                                        </td>
                                                    </>
                                                ) : currentType === "Company Code" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.company_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.company_code}
                                                        </td>
                                                    </>

                                                ) : currentType === "Customer Rejection Reason" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.reason}
                                                        </td>
                                                    </>
                                                ) : currentType === "Country" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.name}
                                                        </td>
                                                        <td style={td}>
                                                            {item.currency || "—"}
                                                        </td>
                                                    </>
                                                ) : currentType === "Machine Config" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.machine_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.machine_description}
                                                        </td>
                                                    </>
                                                ) : currentType === "Process Configuration" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.process_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.process_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.sub_process_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.sub_process_name}
                                                        </td>

                                                        <td style={td}>{item.location}</td>

                                                        <td style={td}>
                                                            {item.group_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.group_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.workcenter_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.workcenter_description}
                                                        </td>

                                                        <td style={td}>
                                                            {item.sample_requirement}
                                                        </td>
                                                    </>

                                                ) : currentType === "Workcenter Config" ? (

                                                    <>
                                                        <td style={td}>
                                                            {item.process_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.process_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.sub_process_id}
                                                        </td>

                                                        <td style={td}>
                                                            {item.sub_process_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.workcenter_name}
                                                        </td>

                                                        <td style={td}>
                                                            {item.workcenter_description}
                                                        </td>
                                                    </>

                                                ) : currentType === "Module Process Config" ? (

                                                    <>
                                                        <td style={td}>{item.module_name}</td>
                                                        <td style={td}>{item.process_name}</td>
                                                        <td style={td}>{item.sub_process_name}</td>
                                                    </>

                                                ) : currentType === "Inspection Test Type" ? (

                                                    <>
                                                        <td style={td}>{item.product_type?.toUpperCase()}</td>
                                                        <td style={td}>{item.sequence}</td>
                                                        <td style={td}>{item.name}</td>
                                                        <td style={td}>{item.drum_assignment || "-"}</td>
                                                    </>

                                                ) : currentType === "MRP Sequence" ? (

                                                    <>
                                                        <td style={td}>{item.product_type?.toUpperCase()}</td>
                                                        <td style={td}>{item.sl_no}</td>
                                                        <td style={td}>{item.process_id}</td>
                                                        <td style={td}>{item.process_name}</td>
                                                        <td style={td}>{item.sub_process_id}</td>
                                                        <td style={td}>{item.sub_process_name}</td>
                                                    </>

                                                ) : currentType === "Number Range" ? (

                                                    <>
                                                        <td style={td}>{item.module_name}</td>
                                                        <td style={td}>{item.prefix}</td>
                                                    </>

                                                ) : currentType === "File Size Config" ? (

                                                    <>
                                                        <td style={td}>{item.module_name}</td>
                                                        <td style={td}>{item.max_size_kb}</td>
                                                    </>

                                                ) : currentType === "RFQ Validity" ? (

                                                    <>
                                                        <td style={td}>{item.module_name}</td>
                                                        <td style={td}>{item.review_type}</td>
                                                        <td style={td}>{item.validity_days}</td>
                                                    </>

                                                ) : currentType === "Tax Configuration" ? (

                                                    <>
                                                        <td style={td}>{item.country}</td>
                                                        <td style={td}>{item.movement_type}</td>
                                                        <td style={td}>{item.tax_type}</td>
                                                    </>

                                                ) : currentType === "GL Code" ? (

                                                    <>
                                                        <td style={td}>{item.gl_category}</td>
                                                        <td style={td}>{item.gl_type}</td>
                                                        <td style={td}>{item.gl_code}</td>
                                                    </>

                                                ) : currentType === "Scrap Configuration" ? (

                                                    <>
                                                        <td style={td}>{item.process_id} - {item.process_name}</td>
                                                        <td style={td}>{item.scrap_name}</td>
                                                    </>

                                                ) : currentType === "Import Validation Rule" ? (

                                                    <>
                                                        <td style={td}>
                                                            {IV_FIELD_OPTIONS
                                                                .filter(o => (item.required_fields || []).includes(o.key))
                                                                .map(o => o.label)
                                                                .join(", ") || "—"}
                                                        </td>
                                                    </>


                                                ) : currentType === "Goods Request Selection Rule" ? (

                                                    <>
                                                        <td style={td}>{item.same_production_order ? "Yes" : "No"}</td>
                                                        <td style={td}>{item.same_product_code ? "Yes" : "No"}</td>
                                                        <td style={td}>{item.same_workcenter ? "Yes" : "No"}</td>
                                                        <td style={td}>{item.max_production_orders ? item.max_production_orders : "No limit"}</td>
                                                    </>

                                                ) : currentType === "Percentage" ? (

                                                    <>
                                                        <td style={td}>{item.percent != null ? `${item.percent}%` : "—"}</td>
                                                    </>

                                                ) : currentType === "Seal & Sign" ? (

                                                    <>
                                                        <td style={td}>{item.username}</td>
                                                        <td style={td}>
                                                            {item.file_path ? (
                                                                <a
                                                                    href={`${SEAL_SIGN_FILE_BASE}${item.file_path}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    View File
                                                                </a>
                                                            ) : "—"}
                                                        </td>
                                                    </>

                                                ) : currentType === "Currency" ? (

                                                    <>
                                                        <td style={td}>{item.name}</td>
                                                        <td style={td}>{item.currency_code || "—"}</td>
                                                        <td style={td}>{item.currency_symbol || "—"}</td>
                                                    </>

                                                ) : currentType === "Business Partner Responsible" ? (

                                                    <>
                                                        <td style={td}>{item.name}</td>
                                                        <td style={td}>{item.phone_number || "—"}</td>
                                                        <td style={td}>{item.email || "—"}</td>
                                                    </>

                                                ) : currentType === "Product Type" ? (

                                                    <>
                                                        <td style={td}>{item.name}</td>
                                                        <td style={td}>{item.usage_type || "—"}</td>
                                                    </>

                                                ) : (

                                                    <td style={td}>
                                                        {item.name}
                                                    </td>

                                                )}

                                                {mode === "add" && (
                                                    <td
                                                        style={{
                                                            ...td,
                                                            minWidth: "180px",
                                                            whiteSpace: "nowrap",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                gap: "6px",
                                                                justifyContent: "center"
                                                            }}
                                                        >
                                                            <button
                                                                style={{
                                                                    ...btn,
                                                                    marginRight: "6px"
                                                                }}
                                                                onClick={() => {
                                                                    if (!canEdit) {
                                                                        showToast(
                                                                            "You don't have Edit access. Please contact admin.",
                                                                            "error"
                                                                        );
                                                                        return;
                                                                    }
                                                                    handleEdit(item);
                                                                }}
                                                            >
                                                                Edit
                                                            </button>

                                                            {currentType !== "Goods Request Selection Rule" && (
                                                            <button
                                                                style={btn}
                                                                onClick={() => {
                                                                    if (!canEdit) {
                                                                        showToast(
                                                                            "You don't have Delete access. Please contact admin.",
                                                                            "error"
                                                                        );
                                                                        return;
                                                                    }
                                                                    handleDelete(item.id);
                                                                }}
                                                            >
                                                                Delete
                                                            </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>

                            {/* FOOTER */}
                            <div style={{
                                padding: "15px 20px",
                                borderTop: "1px solid #e2e8f0",
                                textAlign: "right"
                            }}>
                                <button style={btn} onClick={closeModal}>Close</button>
                            </div>

                        </div>
                    </div>
                )}

                {/* CONFIRM POPUP */}
                {confirmBox.show && (
                    <div style={{ ...overlay, alignItems: "center" }}>
                        <div style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "10px",
                            width: "90vw",
                            maxWidth: "320px",
                            boxSizing: "border-box",
                            textAlign: "center"
                        }}>
                            <h4>Confirm</h4>
                            <p>Are you sure you want to {confirmBox.action} this {currentType}?</p>

                            <button style={{ ...btn, marginRight: "10px" }} onClick={handleConfirm}>Yes</button>
                            <button onClick={() => setConfirmBox({ show: false })}>Cancel</button>
                        </div>
                    </div>
                )}

            </div>


            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />


        </Layout>
    );
};

// STYLES

const overlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.35)",  //  soft shadow (like your 1st pic)
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflowY: "auto",
    overflowX: "hidden",
    padding: "20px 12px",
    boxSizing: "border-box"
};


const modal = {
    background: "#fff",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "1200px",
    // No hard minWidth — on small/narrow viewports the modal must be able
    // to shrink to fit; wide tables inside it get their own horizontal
    // scroll instead of forcing the whole modal (and page) to overflow.
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    boxSizing: "border-box"
};

const input = {
    width: "100%",
    minWidth: "160px",
    boxSizing: "border-box",
    padding: "10px",
    margin: "10px 0",
    borderRadius: "6px",
    border: "1px solid #ccc"
};

export default ProductMaster;